// Üretildi: node scripts/pms-library-template-data.mjs — elle düzenlenmez (ADR 0063 §3).
// Kaynak: docs/gereksinimler/ortak-2026-10-14b/Ship_PMS_Equipment_Components_and_Jobs.xlsx
// (SHA-256 d98950dffd4613a7f2f6ad57b476da6a6ac8802217e72d19e801ad923978666f).
// Yalnız dolu sütunlar; sabit sütunlar bir kez yazılır. Üretildikten sonra `pnpm format`.

export const PMS_LIBRARY_TEMPLATE_SHA256 =
  'd98950dffd4613a7f2f6ad57b476da6a6ac8802217e72d19e801ad923978666f';

/** Bütün satırlarda aynı olan sütunlar. */
export const PMS_LIBRARY_TEMPLATE_CONSTANTS = {
  systemRemarks: 'Vessel-specific; confirm installed equipment',
  taskBasis: 'To be defined',
  reviewStatus: 'Pending technical review',
  planningBasis: 'Calendar / Running Hours / Condition (to select)',
  jobStatus: 'Draft – Review',
} as const;

/** [kod, ad] */
export const TEMPLATE_SYSTEMS: readonly (readonly [string, string])[] = [
  ['01', 'Main Engine & Propulsion'],
  ['02', 'Auxiliary Engines & Generators'],
  ['03', 'Fuel Oil System'],
  ['04', 'Lubricating Oil System'],
  ['05', 'Cooling Water Systems'],
  ['06', 'Compressed Air Systems'],
  ['07', 'Boilers & Steam Systems'],
  ['08', 'Electrical & Automation'],
  ['09', 'Steering Gear'],
  ['10', 'Bilge Ballast & Pumps'],
  ['11', 'Fresh Water & Sewage'],
  ['12', 'Deck Machinery & Mooring'],
  ['13', 'Cargo Handling Systems'],
  ['14', 'Navigation Equipment'],
  ['15', 'Communication & GMDSS'],
  ['16', 'Fire Fighting Systems'],
  ['17', 'Life Saving Appliances'],
  ['18', 'Hull & Structural'],
  ['19', 'Accommodation & HVAC'],
  ['20', 'Pollution Prevention'],
  ['21', 'Safety & Monitoring'],
  ['22', 'Special Vessel Equipment'],
];

/** [kod, sistem kodu, alt sistem, ekipman, bileşenler] */
export const TEMPLATE_ITEMS: readonly (readonly [string, string, string, string, string])[] = [
  ['01-001', '01', 'Main Engine', 'Main Engine No.1 / No.2', 'Main Engine No.1, No.2'],
  [
    '01-002',
    '01',
    'Cylinder Units',
    'Cylinder Head, Liner, Piston, Piston Rings',
    'Cylinder Head, Liner, Piston, Piston Rings',
  ],
  [
    '01-003',
    '01',
    'Fuel Injection',
    'Fuel Injection Pumps, Injectors, Common Rail System',
    'Fuel Injection Pumps, Injectors, Common Rail System',
  ],
  [
    '01-004',
    '01',
    'Valve Mechanism',
    'Exhaust Valves, Inlet Valves, Valve Actuators',
    'Exhaust Valves, Inlet Valves, Valve Actuators',
  ],
  [
    '01-005',
    '01',
    'Turbocharging',
    'Turbocharger, Charge Air Cooler, Air Filters',
    'Turbocharger, Charge Air Cooler, Air Filters',
  ],
  [
    '01-006',
    '01',
    'Starting System',
    'Starting Air Distributor, Starting Valves',
    'Starting Air Distributor, Starting Valves',
  ],
  [
    '01-007',
    '01',
    'Engine Control',
    'Governor, Engine Control Unit, Safety Shutdown',
    'Governor, Engine Control Unit, Safety Shutdown',
  ],
  [
    '01-008',
    '01',
    'Crankcase',
    'Crankcase Oil Mist Detector, Relief Valves',
    'Crankcase Oil Mist Detector, Relief Valves',
  ],
  [
    '01-009',
    '01',
    'Bearings',
    'Main Bearings, Crankpin Bearings, Crosshead Bearings',
    'Main Bearings, Crankpin Bearings, Crosshead Bearings',
  ],
  [
    '01-010',
    '01',
    'Engine Auxiliary',
    'Turning Gear, Indicator Cocks',
    'Turning Gear, Indicator Cocks',
  ],
  [
    '01-011',
    '01',
    'Shafting',
    'Intermediate Shaft, Bearings, Stern Tube',
    'Intermediate Shaft, Bearings, Stern Tube',
  ],
  ['01-012', '01', 'Propeller', 'Fixed Pitch Propeller / CPP', 'Fixed Pitch Propeller, CPP'],
  [
    '01-013',
    '01',
    'Shaft Seals',
    'Forward / Aft Stern Tube Seals',
    'Forward, Aft Stern Tube Seals',
  ],
  ['01-014', '01', 'Gearbox', 'Reduction Gear, Clutch', 'Reduction Gear, Clutch'],
  [
    '01-015',
    '01',
    'Thrusters',
    'Bow Thruster, Stern Thruster, Azimuth Thruster',
    'Bow Thruster, Stern Thruster, Azimuth Thruster',
  ],
  [
    '01-016',
    '01',
    'Monitoring',
    'Shaft Power Meter, Shaft RPM Sensor',
    'Shaft Power Meter, Shaft RPM Sensor',
  ],
  ['02-001', '02', 'Diesel Generators', 'DG No.1, No.2, No.3', 'DG No.1, No.2, No.3'],
  [
    '02-002',
    '02',
    'Emergency Generator',
    'Emergency Diesel Generator',
    'Emergency Diesel Generator',
  ],
  [
    '02-003',
    '02',
    'Generator Engine',
    'Cylinder Head, Injectors, Turbocharger',
    'Cylinder Head, Injectors, Turbocharger',
  ],
  [
    '02-004',
    '02',
    'Alternators',
    'Main Alternators, Emergency Alternator',
    'Main Alternators, Emergency Alternator',
  ],
  ['02-005', '02', 'Starting', 'Starter Motor / Air Starter', 'Starter Motor, Air Starter'],
  [
    '02-006',
    '02',
    'Generator Control',
    'AVR, Governor, Protection Relays',
    'AVR, Governor, Protection Relays',
  ],
  [
    '02-007',
    '02',
    'Synchronization',
    'Synchronizing Equipment, Load Sharing Controller',
    'Synchronizing Equipment, Load Sharing Controller',
  ],
  [
    '02-008',
    '02',
    'Generator Cooling',
    'Jacket Water Pump, Heat Exchanger',
    'Jacket Water Pump, Heat Exchanger',
  ],
  ['02-009', '02', 'Generator Lubrication', 'LO Pump, Filters', 'LO Pump, Filters'],
  ['02-010', '02', 'Generator Fuel', 'Fuel Supply Pump, Filters', 'Fuel Supply Pump, Filters'],
  [
    '02-011',
    '02',
    'Generator Safety',
    'Overspeed Trip, Low LO Pressure Shutdown',
    'Overspeed Trip, Low LO Pressure Shutdown',
  ],
  [
    '03-001',
    '03',
    'Fuel Transfer',
    'HFO / VLSFO / MGO Transfer Pumps',
    'HFO, VLSFO, MGO Transfer Pumps',
  ],
  ['03-002', '03', 'Fuel Supply', 'Fuel Oil Supply Pumps', 'Fuel Oil Supply Pumps'],
  [
    '03-003',
    '03',
    'Fuel Circulation',
    'FO Circulating / Booster Pumps',
    'FO Circulating, Booster Pumps',
  ],
  ['03-004', '03', 'Purification', 'Fuel Oil Purifier No.1 / No.2', 'Fuel Oil Purifier No.1, No.2'],
  ['03-005', '03', 'Heating', 'Fuel Oil Heaters', 'Fuel Oil Heaters'],
  [
    '03-006',
    '03',
    'Filtration',
    'Automatic Backflush Filters, Duplex Filters',
    'Automatic Backflush Filters, Duplex Filters',
  ],
  [
    '03-007',
    '03',
    'Viscosity Control',
    'Viscosity Controller, Sensors',
    'Viscosity Controller, Sensors',
  ],
  [
    '03-008',
    '03',
    'Fuel Measurement',
    'Fuel Flow Meters, Mass Flow Meters',
    'Fuel Flow Meters, Mass Flow Meters',
  ],
  [
    '03-009',
    '03',
    'Fuel Treatment',
    'Mixing Unit, Deaeration Unit',
    'Mixing Unit, Deaeration Unit',
  ],
  [
    '03-010',
    '03',
    'Bunkering',
    'Bunker Manifold Valves, Sampling Equipment',
    'Bunker Manifold Valves, Sampling Equipment',
  ],
  [
    '03-011',
    '03',
    'Tank Equipment',
    'Quick Closing Valves, Level Gauges, High-Level Alarms',
    'Quick Closing Valves, Level Gauges, High-Level Alarms',
  ],
  [
    '03-012',
    '03',
    'Fuel Changeover',
    'Changeover Valves, Changeover Control Unit',
    'Changeover Valves, Changeover Control Unit',
  ],
  [
    '04-001',
    '04',
    'Main Engine LO',
    'Main LO Pump, Standby LO Pump',
    'Main LO Pump, Standby LO Pump',
  ],
  ['04-002', '04', 'LO Purification', 'LO Purifier', 'LO Purifier'],
  ['04-003', '04', 'LO Cooling', 'LO Cooler', 'LO Cooler'],
  [
    '04-004',
    '04',
    'LO Filtration',
    'Automatic / Duplex LO Filters',
    'Automatic, Duplex LO Filters',
  ],
  ['04-005', '04', 'LO Transfer', 'LO Transfer Pump', 'LO Transfer Pump'],
  [
    '04-006',
    '04',
    'Generator LO',
    'Generator LO Pumps and Filters',
    'Generator LO Pumps and Filters',
  ],
  ['04-007', '04', 'Gearbox LO', 'Gearbox LO Pump and Cooler', 'Gearbox LO Pump and Cooler'],
  [
    '04-008',
    '04',
    'Stern Tube LO',
    'Stern Tube LO Circulation / Header System',
    'Stern Tube LO Circulation, Header System',
  ],
  [
    '04-009',
    '04',
    'Oil Monitoring',
    'LO Pressure, Temperature, Level Sensors',
    'LO Pressure, Temperature, Level Sensors',
  ],
  [
    '04-010',
    '04',
    'Oil Analysis',
    'Oil Sampling and Analysis Schedule',
    'Oil Sampling and Analysis Schedule',
  ],
  [
    '05-001',
    '05',
    'Sea Water Cooling',
    'Main / Standby Sea Water Pumps',
    'Main, Standby Sea Water Pumps',
  ],
  ['05-002', '05', 'Fresh Water Cooling', 'HT / LT Cooling Pumps', 'HT, LT Cooling Pumps'],
  [
    '05-003',
    '05',
    'Central Cooling',
    'Central Coolers, Plate Heat Exchangers',
    'Central Coolers, Plate Heat Exchangers',
  ],
  ['05-004', '05', 'Engine Cooling', 'Jacket Water Pumps', 'Jacket Water Pumps'],
  [
    '05-005',
    '05',
    'Sea Water Intake',
    'Sea Chest Valves, Strainers',
    'Sea Chest Valves, Strainers',
  ],
  ['05-006', '05', 'Temperature Control', 'Thermostatic Valves', 'Thermostatic Valves'],
  [
    '05-007',
    '05',
    'Chemical Treatment',
    'Dosing Unit, Water Testing',
    'Dosing Unit, Water Testing',
  ],
  ['05-008', '05', 'Expansion', 'Expansion Tanks, Level Alarms', 'Expansion Tanks, Level Alarms'],
  [
    '05-009',
    '05',
    'Cooling Monitoring',
    'Temperature and Pressure Sensors',
    'Temperature and Pressure Sensors',
  ],
  [
    '06-001',
    '06',
    'Starting Air',
    'Main Air Compressor No.1 / No.2',
    'Main Air Compressor No.1, No.2',
  ],
  ['06-002', '06', 'Emergency Air', 'Emergency Air Compressor', 'Emergency Air Compressor'],
  ['06-003', '06', 'Service Air', 'Service Air Compressor', 'Service Air Compressor'],
  [
    '06-004',
    '06',
    'Air Receivers',
    'Starting Air Bottles, Service Air Receivers',
    'Starting Air Bottles, Service Air Receivers',
  ],
  [
    '06-005',
    '06',
    'Air Treatment',
    'Air Dryers, Moisture Separators',
    'Air Dryers, Moisture Separators',
  ],
  [
    '06-006',
    '06',
    'Air Safety',
    'Safety Valves, Pressure Switches',
    'Safety Valves, Pressure Switches',
  ],
  [
    '06-007',
    '06',
    'Air Distribution',
    'Reducing Valves, Non-Return Valves',
    'Reducing Valves, Non-Return Valves',
  ],
  ['06-008', '06', 'Air Control', 'Pneumatic Control Units', 'Pneumatic Control Units'],
  ['07-001', '07', 'Auxiliary Boiler', 'Oil Fired Boiler', 'Oil Fired Boiler'],
  ['07-002', '07', 'Exhaust Gas Boiler', 'Exhaust Gas Economizer', 'Exhaust Gas Economizer'],
  ['07-003', '07', 'Composite Boiler', 'Composite Boiler', 'Composite Boiler'],
  ['07-004', '07', 'Burner', 'Burner Unit, Ignition System', 'Burner Unit, Ignition System'],
  ['07-005', '07', 'Feed Water', 'Boiler Feed Pumps', 'Boiler Feed Pumps'],
  ['07-006', '07', 'Water Treatment', 'Chemical Dosing Unit', 'Chemical Dosing Unit'],
  [
    '07-007',
    '07',
    'Steam System',
    'Steam Traps, Pressure Reducing Stations',
    'Steam Traps, Pressure Reducing Stations',
  ],
  ['07-008', '07', 'Condensate', 'Condensate Pumps, Hotwell', 'Condensate Pumps, Hotwell'],
  [
    '07-009',
    '07',
    'Safety',
    'Boiler Safety Valves, Low Water Cut-Out',
    'Boiler Safety Valves, Low Water Cut-Out',
  ],
  [
    '07-010',
    '07',
    'Monitoring',
    'Water Level Gauges, Pressure Controls',
    'Water Level Gauges, Pressure Controls',
  ],
  [
    '08-001',
    '08',
    'Main Switchboard',
    'MSB, Circuit Breakers, Bus Tie',
    'MSB, Circuit Breakers, Bus Tie',
  ],
  ['08-002', '08', 'Emergency Switchboard', 'ESB, Emergency Breakers', 'ESB, Emergency Breakers'],
  [
    '08-003',
    '08',
    'Distribution',
    'Distribution Boards, MCC Panels',
    'Distribution Boards, MCC Panels',
  ],
  ['08-004', '08', 'Transformers', 'Power Transformers', 'Power Transformers'],
  ['08-005', '08', 'UPS', 'UPS Units, Battery Banks', 'UPS Units, Battery Banks'],
  ['08-006', '08', 'Batteries', 'Emergency Batteries, Chargers', 'Emergency Batteries, Chargers'],
  ['08-007', '08', 'Shore Power', 'Shore Connection Panel', 'Shore Connection Panel'],
  [
    '08-008',
    '08',
    'Insulation Monitoring',
    'Earth Fault / Insulation Monitoring',
    'Earth Fault, Insulation Monitoring',
  ],
  [
    '08-009',
    '08',
    'Power Management',
    'PMS Power Management Controller',
    'PMS Power Management Controller',
  ],
  [
    '08-010',
    '08',
    'Automation',
    'Alarm Monitoring System, PLC Units',
    'Alarm Monitoring System, PLC Units',
  ],
  ['08-011', '08', 'Engine Monitoring', 'Engine Room Alarm System', 'Engine Room Alarm System'],
  [
    '08-012',
    '08',
    'Remote Control',
    'Bridge Engine Control, Local Control',
    'Bridge Engine Control, Local Control',
  ],
  [
    '08-013',
    '08',
    'Sensors',
    'Pressure, Temperature, Level Transmitters',
    'Pressure, Temperature, Level Transmitters',
  ],
  [
    '08-014',
    '08',
    'Emergency Shutdown',
    'ESD Circuits, Shutdown Controls',
    'ESD Circuits, Shutdown Controls',
  ],
  ['09-001', '09', 'Steering Gear', 'Main Steering Gear', 'Main Steering Gear'],
  ['09-002', '09', 'Hydraulic System', 'Hydraulic Pumps No.1 / No.2', 'Hydraulic Pumps No.1, No.2'],
  ['09-003', '09', 'Actuators', 'Hydraulic Rams / Rotary Vane', 'Hydraulic Rams, Rotary Vane'],
  ['09-004', '09', 'Rudder', 'Rudder Stock, Bearings, Seals', 'Rudder Stock, Bearings, Seals'],
  ['09-005', '09', 'Control', 'Steering Control System', 'Steering Control System'],
  [
    '09-006',
    '09',
    'Emergency Steering',
    'Emergency Steering Arrangement',
    'Emergency Steering Arrangement',
  ],
  ['09-007', '09', 'Monitoring', 'Rudder Angle Indicators', 'Rudder Angle Indicators'],
  [
    '09-008',
    '09',
    'Safety',
    'Low Level Alarms, Power Failure Alarms',
    'Low Level Alarms, Power Failure Alarms',
  ],
  [
    '10-001',
    '10',
    'Bilge Pumps',
    'Bilge Pump, Emergency Bilge Pump',
    'Bilge Pump, Emergency Bilge Pump',
  ],
  [
    '10-002',
    '10',
    'General Service',
    'General Service / Fire & Bilge Pump',
    'General Service, Fire & Bilge Pump',
  ],
  ['10-003', '10', 'Ballast Pumps', 'Ballast Pump No.1 / No.2', 'Ballast Pump No.1, No.2'],
  ['10-004', '10', 'Eductors', 'Bilge / Ballast Eductors', 'Bilge, Ballast Eductors'],
  [
    '10-005',
    '10',
    'Valves',
    'Remote Operated Valves, Critical Isolation Valves',
    'Remote Operated Valves, Critical Isolation Valves',
  ],
  [
    '10-006',
    '10',
    'Bilge Wells',
    'Bilge Level Sensors, High-Level Alarms',
    'Bilge Level Sensors, High-Level Alarms',
  ],
  [
    '10-007',
    '10',
    'Ballast Monitoring',
    'Tank Level Gauges, Remote Sounding',
    'Tank Level Gauges, Remote Sounding',
  ],
  [
    '10-008',
    '10',
    'Pipework',
    'Critical Pipe Sections, Expansion Joints',
    'Critical Pipe Sections, Expansion Joints',
  ],
  ['10-009', '10', 'Ballast Control', 'Ballast Control Panel', 'Ballast Control Panel'],
  [
    '11-001',
    '11',
    'Fresh Water Generation',
    'Fresh Water Generator / RO Watermaker',
    'Fresh Water Generator, RO Watermaker',
  ],
  ['11-002', '11', 'Potable Water', 'Hydrophore Pumps', 'Hydrophore Pumps'],
  [
    '11-003',
    '11',
    'Fresh Water Treatment',
    'UV Sterilizer, Chlorination Unit',
    'UV Sterilizer, Chlorination Unit',
  ],
  [
    '11-004',
    '11',
    'Hot Water',
    'Calorifier, Hot Water Circulation Pump',
    'Calorifier, Hot Water Circulation Pump',
  ],
  ['11-005', '11', 'Sewage', 'Sewage Treatment Plant', 'Sewage Treatment Plant'],
  ['11-006', '11', 'Sewage Transfer', 'Sewage / Grey Water Pumps', 'Sewage, Grey Water Pumps'],
  [
    '11-007',
    '11',
    'Vacuum Toilets',
    'Vacuum Pumps, Collection Unit',
    'Vacuum Pumps, Collection Unit',
  ],
  [
    '11-008',
    '11',
    'Water Monitoring',
    'Potable Water Testing, Tank Hygiene',
    'Potable Water Testing, Tank Hygiene',
  ],
  ['11-009', '11', 'Domestic Water', 'Filters, Pressure Tanks', 'Filters, Pressure Tanks'],
  [
    '12-001',
    '12',
    'Windlass',
    'Port / Starboard Anchor Windlass',
    'Port, Starboard Anchor Windlass',
  ],
  ['12-002', '12', 'Anchors', 'Anchor, Chain, Joining Shackles', 'Anchor, Chain, Joining Shackles'],
  [
    '12-003',
    '12',
    'Mooring Winches',
    'Forward / Aft Mooring Winches',
    'Forward, Aft Mooring Winches',
  ],
  ['12-004', '12', 'Capstans', 'Mooring Capstans', 'Mooring Capstans'],
  ['12-005', '12', 'Mooring Equipment', 'Ropes, Wires, Tails', 'Ropes, Wires, Tails'],
  [
    '12-006',
    '12',
    'Deck Fittings',
    'Bollards, Fairleads, Rollers, Chain Stoppers',
    'Bollards, Fairleads, Rollers, Chain Stoppers',
  ],
  ['12-007', '12', 'Hydraulic Power', 'Deck Hydraulic Power Packs', 'Deck Hydraulic Power Packs'],
  [
    '12-008',
    '12',
    'Gangway',
    'Accommodation Ladder, Gangway, Hoist',
    'Accommodation Ladder, Gangway, Hoist',
  ],
  [
    '12-009',
    '12',
    'Pilot Ladder',
    'Pilot Ladder, Securing Arrangements',
    'Pilot Ladder, Securing Arrangements',
  ],
  [
    '12-010',
    '12',
    'Deck Cranes',
    'Provision Crane, Hose Handling Crane',
    'Provision Crane, Hose Handling Crane',
  ],
  [
    '12-011',
    '12',
    'Hatch Covers',
    'Hatch Cover Hydraulic System, Seals, Cleats',
    'Hatch Cover Hydraulic System, Seals, Cleats',
  ],
  [
    '13-001',
    '13',
    'General Cargo / Bulk',
    'Cargo Cranes, Cargo Derricks',
    'Cargo Cranes, Cargo Derricks',
  ],
  [
    '13-002',
    '13',
    'Bulk Carrier',
    'Hatch Covers, Hydraulic Cylinders',
    'Hatch Covers, Hydraulic Cylinders',
  ],
  [
    '13-003',
    '13',
    'Bulk Carrier',
    'Hold Bilge Alarms, Water Ingress Detection',
    'Hold Bilge Alarms, Water Ingress Detection',
  ],
  [
    '13-004',
    '13',
    'Container Vessel',
    'Reefer Sockets, Reefer Monitoring',
    'Reefer Sockets, Reefer Monitoring',
  ],
  ['13-005', '13', 'Tanker', 'Cargo Pumps, Stripping Pumps', 'Cargo Pumps, Stripping Pumps'],
  [
    '13-006',
    '13',
    'Tanker',
    'Cargo Valves, Remote Valve Controls',
    'Cargo Valves, Remote Valve Controls',
  ],
  ['13-007', '13', 'Tanker', 'Inert Gas System', 'Inert Gas System'],
  ['13-008', '13', 'Tanker', 'Tank Cleaning Machines', 'Tank Cleaning Machines'],
  ['13-009', '13', 'Tanker', 'Cargo Heating System', 'Cargo Heating System'],
  ['13-010', '13', 'Tanker', 'ODME, Cargo Tank Level Gauges', 'ODME, Cargo Tank Level Gauges'],
  [
    '13-011',
    '13',
    'Gas Carrier',
    'Cargo Compressors, Reliquefaction Plant',
    'Cargo Compressors, Reliquefaction Plant',
  ],
  [
    '13-012',
    '13',
    'Gas Carrier',
    'Cargo Tank Pressure / Temperature Systems',
    'Cargo Tank Pressure, Temperature Systems',
  ],
  [
    '13-013',
    '13',
    'Ro-Ro',
    'Stern Ramp, Bow Ramp, Hydraulic Systems',
    'Stern Ramp, Bow Ramp, Hydraulic Systems',
  ],
  [
    '13-014',
    '13',
    'Ro-Ro',
    'Vehicle Deck Ventilation, Ramp Interlocks',
    'Vehicle Deck Ventilation, Ramp Interlocks',
  ],
  ['14-001', '14', 'Radar', 'X-Band Radar, S-Band Radar', 'X-Band Radar, S-Band Radar'],
  ['14-002', '14', 'ECDIS', 'Primary / Backup ECDIS', 'Primary, Backup ECDIS'],
  ['14-003', '14', 'GNSS', 'GPS / GNSS Receivers', 'GPS, GNSS Receivers'],
  ['14-004', '14', 'Gyro', 'Gyro Compass, Repeaters', 'Gyro Compass, Repeaters'],
  [
    '14-005',
    '14',
    'Magnetic Compass',
    'Magnetic Compass, Deviation Check',
    'Magnetic Compass, Deviation Check',
  ],
  ['14-006', '14', 'AIS', 'AIS Transponder', 'AIS Transponder'],
  ['14-007', '14', 'Echo Sounder', 'Echo Sounder, Transducer', 'Echo Sounder, Transducer'],
  [
    '14-008',
    '14',
    'Speed Log',
    'Doppler / Electromagnetic Speed Log',
    'Doppler, Electromagnetic Speed Log',
  ],
  ['14-009', '14', 'Autopilot', 'Autopilot / Track Control', 'Autopilot, Track Control'],
  ['14-010', '14', 'BNWAS', 'Bridge Navigational Watch Alarm', 'Bridge Navigational Watch Alarm'],
  ['14-011', '14', 'VDR', 'VDR / S-VDR', 'VDR, S-VDR'],
  [
    '14-012',
    '14',
    'Navigation Lights',
    'Navigation Light System, Failure Alarm',
    'Navigation Light System, Failure Alarm',
  ],
  ['14-013', '14', 'Sound Signals', "Ship's Whistle, Fog Signal", "Ship's Whistle, Fog Signal"],
  ['14-014', '14', 'Meteorological', 'Anemometer, Barometer', 'Anemometer, Barometer'],
  [
    '14-015',
    '14',
    'Bridge Indicators',
    'Rate of Turn Indicator, Rudder Angle Indicator',
    'Rate of Turn Indicator, Rudder Angle Indicator',
  ],
  ['15-001', '15', 'VHF', 'Fixed VHF / DSC Radios', 'Fixed VHF, DSC Radios'],
  ['15-002', '15', 'MF/HF', 'MF/HF DSC Radio', 'MF/HF DSC Radio'],
  [
    '15-003',
    '15',
    'Satellite',
    'Inmarsat-C / Recognized Satellite GMDSS Terminal',
    'Inmarsat-C, Recognized Satellite GMDSS Terminal',
  ],
  ['15-004', '15', 'EPIRB', '406 MHz EPIRB', '406 MHz EPIRB'],
  ['15-005', '15', 'SART', 'Radar SART / AIS-SART', 'Radar SART, AIS-SART'],
  ['15-006', '15', 'NAVTEX', 'NAVTEX Receiver', 'NAVTEX Receiver'],
  ['15-007', '15', 'Portable Radios', 'Survival Craft Two-Way VHF', 'Survival Craft Two-Way VHF'],
  [
    '15-008',
    '15',
    'Emergency Communications',
    'Emergency Batteries, Chargers',
    'Emergency Batteries, Chargers',
  ],
  [
    '15-009',
    '15',
    'Internal Communications',
    'Talkback, Intercom, Public Address',
    'Talkback, Intercom, Public Address',
  ],
  ['15-010', '15', 'General Alarm', 'General Alarm System', 'General Alarm System'],
  [
    '15-011',
    '15',
    'Signalling',
    'Signal Lamps, Daylight Signalling Lamp',
    'Signal Lamps, Daylight Signalling Lamp',
  ],
  ['15-012', '15', 'SSAS', 'Ship Security Alert System', 'Ship Security Alert System'],
  [
    '15-013',
    '15',
    'LRIT',
    'LRIT Terminal / Reporting Equipment',
    'LRIT Terminal, Reporting Equipment',
  ],
  ['16-001', '16', 'Fire Pumps', 'Main Fire Pumps', 'Main Fire Pumps'],
  ['16-002', '16', 'Emergency Fire Pump', 'Emergency Fire Pump', 'Emergency Fire Pump'],
  [
    '16-003',
    '16',
    'Fire Main',
    'Hydrants, Hoses, Nozzles, Isolation Valves',
    'Hydrants, Hoses, Nozzles, Isolation Valves',
  ],
  [
    '16-004',
    '16',
    'Fire Detection',
    'Fire Detection Control Panel',
    'Fire Detection Control Panel',
  ],
  ['16-005', '16', 'Detectors', 'Smoke, Heat, Flame Detectors', 'Smoke, Heat, Flame Detectors'],
  [
    '16-006',
    '16',
    'Fixed CO2',
    'CO2 Cylinders, Release Cabinet, Alarms',
    'CO2 Cylinders, Release Cabinet, Alarms',
  ],
  ['16-007', '16', 'Water Mist', 'Water Mist / Sprinkler System', 'Water Mist, Sprinkler System'],
  [
    '16-008',
    '16',
    'Foam System',
    'Foam Pumps, Foam Tank, Proportioner',
    'Foam Pumps, Foam Tank, Proportioner',
  ],
  [
    '16-009',
    '16',
    'Portable Extinguishers',
    'CO2, Foam, Dry Powder Extinguishers',
    'CO2, Foam, Dry Powder Extinguishers',
  ],
  ['16-010', '16', 'Fire Dampers', 'Fire Dampers, Remote Closing', 'Fire Dampers, Remote Closing'],
  ['16-011', '16', 'Ventilation Stops', 'Emergency Fan Stops', 'Emergency Fan Stops'],
  ['16-012', '16', 'Fire Doors', 'Self-Closing Fire Doors', 'Self-Closing Fire Doors'],
  [
    '16-013',
    '16',
    "Fireman's Outfit",
    'Firefighter Equipment, SCBA',
    'Firefighter Equipment, SCBA',
  ],
  [
    '16-014',
    '16',
    'EEBD',
    'Emergency Escape Breathing Devices',
    'Emergency Escape Breathing Devices',
  ],
  ['16-015', '16', 'Escape Systems', 'Emergency Escape Lighting', 'Emergency Escape Lighting'],
  ['17-001', '17', 'Lifeboats', 'Port / Starboard Lifeboats', 'Port, Starboard Lifeboats'],
  [
    '17-002',
    '17',
    'Lifeboat Engines',
    'Lifeboat Engine and Starting System',
    'Lifeboat Engine and Starting System',
  ],
  ['17-003', '17', 'Davits', 'Lifeboat Davits, Winches, Falls', 'Lifeboat Davits, Winches, Falls'],
  ['17-004', '17', 'Rescue Boat', 'Rescue Boat and Engine', 'Rescue Boat and Engine'],
  ['17-005', '17', 'Liferafts', 'Inflatable Liferafts', 'Inflatable Liferafts'],
  ['17-006', '17', 'Hydrostatic Release', 'HRU', 'HRU'],
  ['17-007', '17', 'Lifejackets', 'Lifejackets, Lights, Whistles', 'Lifejackets, Lights, Whistles'],
  ['17-008', '17', 'Immersion Suits', 'Immersion Suits', 'Immersion Suits'],
  [
    '17-009',
    '17',
    'Lifebuoys',
    'Lifebuoys, Lights, Smoke Signals',
    'Lifebuoys, Lights, Smoke Signals',
  ],
  [
    '17-010',
    '17',
    'Pyrotechnics',
    'Distress Flares, Rocket Signals',
    'Distress Flares, Rocket Signals',
  ],
  [
    '17-011',
    '17',
    'Survival Equipment',
    'Lifeboat / Liferaft Inventory',
    'Lifeboat, Liferaft Inventory',
  ],
  [
    '17-012',
    '17',
    'Launching Equipment',
    'Release Gear, Hooks, Interlocks',
    'Release Gear, Hooks, Interlocks',
  ],
  ['18-001', '18', 'Hull', 'Hull Structure, Coating', 'Hull Structure, Coating'],
  ['18-002', '18', 'Deck', 'Weather Deck, Deck Plating', 'Weather Deck, Deck Plating'],
  ['18-003', '18', 'Bulkheads', 'Watertight Bulkheads', 'Watertight Bulkheads'],
  [
    '18-004',
    '18',
    'Doors',
    'Watertight Doors, Weathertight Doors',
    'Watertight Doors, Weathertight Doors',
  ],
  ['18-005', '18', 'Hatches', 'Access Hatches, Manholes', 'Access Hatches, Manholes'],
  ['18-006', '18', 'Tank Structure', 'Ballast Tanks, Void Spaces', 'Ballast Tanks, Void Spaces'],
  ['18-007', '18', 'Corrosion Protection', 'Sacrificial Anodes, ICCP', 'Sacrificial Anodes, ICCP'],
  [
    '18-008',
    '18',
    'Sea Connections',
    'Overboard Valves, Sea Chest Valves',
    'Overboard Valves, Sea Chest Valves',
  ],
  ['18-009', '18', 'Pipe Penetrations', 'Watertight Penetrations', 'Watertight Penetrations'],
  [
    '18-010',
    '18',
    'Structural Inspections',
    'Corrosion, Cracks, Deformation',
    'Corrosion, Cracks, Deformation',
  ],
  [
    '18-011',
    '18',
    'Ventilation Closures',
    'Air Pipes, Vent Heads, Closing Devices',
    'Air Pipes, Vent Heads, Closing Devices',
  ],
  [
    '18-012',
    '18',
    'Tank Monitoring',
    'Tank Sounding Pipes, Remote Level Systems',
    'Tank Sounding Pipes, Remote Level Systems',
  ],
  [
    '19-001',
    '19',
    'Air Conditioning',
    'HVAC Compressors, Condensers',
    'HVAC Compressors, Condensers',
  ],
  ['19-002', '19', 'Ventilation', 'Supply / Exhaust Fans', 'Supply, Exhaust Fans'],
  [
    '19-003',
    '19',
    'Refrigeration',
    'Provision Refrigeration Plant',
    'Provision Refrigeration Plant',
  ],
  ['19-004', '19', 'Cold Rooms', 'Cold Room Temperature Alarms', 'Cold Room Temperature Alarms'],
  ['19-005', '19', 'Galley', 'Ovens, Cooking Equipment', 'Ovens, Cooking Equipment'],
  ['19-006', '19', 'Laundry', 'Washing Machines, Dryers', 'Washing Machines, Dryers'],
  ['19-007', '19', 'Lifts', 'Passenger / Service Lifts', 'Passenger, Service Lifts'],
  ['19-008', '19', 'Accommodation Safety', 'Emergency Lighting', 'Emergency Lighting'],
  ['19-009', '19', 'Ventilation Safety', 'Fire Dampers, Fan Stops', 'Fire Dampers, Fan Stops'],
  [
    '19-010',
    '19',
    'Medical',
    'Medical Refrigerators, Relevant Medical Equipment',
    'Medical Refrigerators, Relevant Medical Equipment',
  ],
  ['20-001', '20', 'Oily Water Separator', 'OWS Unit', 'OWS Unit'],
  ['20-002', '20', 'Oil Monitoring', '15 ppm Bilge Alarm', '15 ppm Bilge Alarm'],
  [
    '20-003',
    '20',
    'Sludge',
    'Sludge Transfer Pump, Sludge Incinerator',
    'Sludge Transfer Pump, Sludge Incinerator',
  ],
  ['20-004', '20', 'Sewage', 'Sewage Treatment Plant', 'Sewage Treatment Plant'],
  ['20-005', '20', 'Garbage', 'Garbage Compactor, Shredder', 'Garbage Compactor, Shredder'],
  ['20-006', '20', 'Incinerator', 'Waste Incinerator', 'Waste Incinerator'],
  [
    '20-007',
    '20',
    'Ballast Water',
    'Ballast Water Treatment System',
    'Ballast Water Treatment System',
  ],
  [
    '20-008',
    '20',
    'BWTS Monitoring',
    'UV Sensors, TRO Sensors, Sampling Devices',
    'UV Sensors, TRO Sensors, Sampling Devices',
  ],
  ['20-009', '20', 'Emission Control', 'Scrubber / EGCS', 'Scrubber, EGCS'],
  ['20-010', '20', 'NOx Control', 'SCR / EGR Equipment', 'SCR, EGR Equipment'],
  [
    '20-011',
    '20',
    'Refrigerant Systems',
    'Refrigerant Leak Detection',
    'Refrigerant Leak Detection',
  ],
  ['20-012', '20', 'Spill Response', 'SOPEP Equipment, Spill Kits', 'SOPEP Equipment, Spill Kits'],
  ['21-001', '21', 'Gas Detection', 'Fixed Gas Detection System', 'Fixed Gas Detection System'],
  [
    '21-002',
    '21',
    'Portable Gas Detectors',
    'O2, LEL, H2S, CO Detectors',
    'O2, LEL, H2S, CO Detectors',
  ],
  [
    '21-003',
    '21',
    'Enclosed Space',
    'Gas Sampling Equipment, Rescue Equipment',
    'Gas Sampling Equipment, Rescue Equipment',
  ],
  ['21-004', '21', 'Emergency Stops', 'Emergency Stop Stations', 'Emergency Stop Stations'],
  ['21-005', '21', 'CCTV', 'CCTV Cameras and Recorder', 'CCTV Cameras and Recorder'],
  ['21-006', '21', 'Access Control', 'Security Access System', 'Security Access System'],
  [
    '21-007',
    '21',
    'Fire / Safety Monitoring',
    'Integrated Alarm System',
    'Integrated Alarm System',
  ],
  [
    '21-008',
    '21',
    'Safety Instruments',
    'Portable Calibration Instruments',
    'Portable Calibration Instruments',
  ],
  [
    '21-009',
    '21',
    'PPE',
    'Safety Harnesses, Fall Arrest Equipment',
    'Safety Harnesses, Fall Arrest Equipment',
  ],
  [
    '21-010',
    '21',
    'Lifting Gear',
    'Chain Blocks, Slings, Shackles',
    'Chain Blocks, Slings, Shackles',
  ],
  [
    '21-011',
    '21',
    'Workshop',
    'Grinding Machines, Welding Equipment',
    'Grinding Machines, Welding Equipment',
  ],
  [
    '21-012',
    '21',
    'Testing Equipment',
    'Multimeters, Megger, Pressure Test Instruments',
    'Multimeters, Megger, Pressure Test Instruments',
  ],
  [
    '22-001',
    '22',
    'Dynamic Positioning Vessel',
    'DP Computers, Position Reference Systems, DP Sensors',
    'DP Computers, Position Reference Systems, DP Sensors',
  ],
  [
    '22-002',
    '22',
    'Offshore Vessel',
    'Towing Winches, Shark Jaws, Towing Pins',
    'Towing Winches, Shark Jaws, Towing Pins',
  ],
  [
    '22-003',
    '22',
    'Offshore Crane Vessel',
    'Heavy Lift Cranes, Load Monitoring',
    'Heavy Lift Cranes, Load Monitoring',
  ],
  [
    '22-004',
    '22',
    'Survey Vessel',
    'Sonar, Multibeam, Survey Sensors',
    'Sonar, Multibeam, Survey Sensors',
  ],
  [
    '22-005',
    '22',
    'Passenger Vessel',
    'Passenger Doors, Evacuation Systems',
    'Passenger Doors, Evacuation Systems',
  ],
  [
    '22-006',
    '22',
    'Yacht',
    'Stabilizers, Watermakers, Tender Davits',
    'Stabilizers, Watermakers, Tender Davits',
  ],
  [
    '22-007',
    '22',
    'Yacht',
    'Jacuzzi / Pool Pumps, Garage Doors',
    'Jacuzzi, Pool Pumps, Garage Doors',
  ],
  [
    '22-008',
    '22',
    'Fishing Vessel',
    'Fishing Winches, Net Haulers, Refrigeration',
    'Fishing Winches, Net Haulers, Refrigeration',
  ],
  [
    '22-009',
    '22',
    'Dredger',
    'Dredge Pumps, Cutter Heads, Suction Systems',
    'Dredge Pumps, Cutter Heads, Suction Systems',
  ],
  [
    '22-010',
    '22',
    'Ice-Class Vessel',
    'Ice-Related Machinery, Heating Arrangements',
    'Ice-Related Machinery, Heating Arrangements',
  ],
];

/** İş başlıkları (tekrar edenler bir kez). */
export const TEMPLATE_JOB_TITLES: readonly string[] = [
  'Inspect for leakage, abnormal noise and vibration',
  'Check operating parameters, alarms and safety devices',
  'Inspect lubrication, cooling and fuel connections',
  'Clean/replace serviceable filters and inspect wear as applicable',
  'Visual inspection for condition, leakage, wear and damage',
  'Functional/operational check where applicable',
  'Clean, lubricate or service as applicable',
  'Record defects and corrective action if found',
  'Inspect leakage, vibration, noise and mounting',
  'Check suction/discharge pressure and operating performance',
  'Inspect seals, bearings and lubrication',
  'Test standby/changeover and protections where fitted',
  'Visual inspection for corrosion, leakage and damage',
  'Function-test opening/closing and local/remote operation',
  'Inspect seals, actuators and securing arrangements',
  'Inspect cleanliness, corrosion, connections and ventilation',
  'Test alarms, protection and functional operation',
  'Check electrical condition/insulation as applicable',
  'Inspect sensor condition, wiring and connections',
  'Function-test alarms, indications and interlocks',
  'Verify calibration status where applicable',
  'Inspect leakage, fouling and operating parameters',
  'Clean/service accessible elements and check consumables',
  'Function-test alarms, controls and protective devices',
  'Inspect structural condition, corrosion and coating',
  'Check tightness, fittings and protective arrangements',
  'Record findings and raise repair work orders as required',
  'Inspect condition, accessibility, markings and inventory',
  'Conduct permitted functional tests and checks',
  'Check service dates, expiry and statutory inspection requirements',
  'Inspect structural condition, wires, ropes and fittings',
  'Check lubrication, brakes, limit switches and controls',
  'Function-test and inspect hydraulic/electrical drives',
  'Conduct operational/self-test and check indications',
  'Inspect power supply, antennas, sensors and connections',
  'Check configuration, records and required service status',
];

/**
 * [iş kodu, kalem kodu, başlık sırası, tür (I Inspection, T Test, M Maintenance), departman
 * (E Engine, D Deck, boş atanmamış)]
 */
export const TEMPLATE_JOBS: readonly (readonly [
  string,
  string,
  number,
  'I' | 'T' | 'M',
  'E' | 'D' | '',
])[] = [
  ['JOB-01-001-01', '01-001', 0, 'I', 'E'],
  ['JOB-01-001-02', '01-001', 1, 'T', 'E'],
  ['JOB-01-001-03', '01-001', 2, 'I', 'E'],
  ['JOB-01-001-04', '01-001', 3, 'I', 'E'],
  ['JOB-01-002-01', '01-002', 4, 'I', 'E'],
  ['JOB-01-002-02', '01-002', 5, 'T', 'E'],
  ['JOB-01-002-03', '01-002', 6, 'M', 'E'],
  ['JOB-01-002-04', '01-002', 7, 'M', 'E'],
  ['JOB-01-003-01', '01-003', 8, 'I', 'E'],
  ['JOB-01-003-02', '01-003', 9, 'T', 'E'],
  ['JOB-01-003-03', '01-003', 10, 'I', 'E'],
  ['JOB-01-003-04', '01-003', 11, 'T', 'E'],
  ['JOB-01-004-01', '01-004', 12, 'I', 'E'],
  ['JOB-01-004-02', '01-004', 13, 'T', 'E'],
  ['JOB-01-004-03', '01-004', 14, 'I', 'E'],
  ['JOB-01-005-01', '01-005', 15, 'I', 'E'],
  ['JOB-01-005-02', '01-005', 16, 'T', 'E'],
  ['JOB-01-005-03', '01-005', 17, 'T', 'E'],
  ['JOB-01-006-01', '01-006', 12, 'I', 'E'],
  ['JOB-01-006-02', '01-006', 13, 'T', 'E'],
  ['JOB-01-006-03', '01-006', 14, 'I', 'E'],
  ['JOB-01-007-01', '01-007', 0, 'I', 'E'],
  ['JOB-01-007-02', '01-007', 1, 'T', 'E'],
  ['JOB-01-007-03', '01-007', 2, 'I', 'E'],
  ['JOB-01-007-04', '01-007', 3, 'I', 'E'],
  ['JOB-01-008-01', '01-008', 12, 'I', 'E'],
  ['JOB-01-008-02', '01-008', 13, 'T', 'E'],
  ['JOB-01-008-03', '01-008', 14, 'I', 'E'],
  ['JOB-01-009-01', '01-009', 4, 'I', 'E'],
  ['JOB-01-009-02', '01-009', 5, 'T', 'E'],
  ['JOB-01-009-03', '01-009', 6, 'M', 'E'],
  ['JOB-01-009-04', '01-009', 7, 'M', 'E'],
  ['JOB-01-010-01', '01-010', 0, 'I', 'E'],
  ['JOB-01-010-02', '01-010', 1, 'T', 'E'],
  ['JOB-01-010-03', '01-010', 2, 'I', 'E'],
  ['JOB-01-010-04', '01-010', 3, 'I', 'E'],
  ['JOB-01-011-01', '01-011', 4, 'I', 'E'],
  ['JOB-01-011-02', '01-011', 5, 'T', 'E'],
  ['JOB-01-011-03', '01-011', 6, 'M', 'E'],
  ['JOB-01-011-04', '01-011', 7, 'M', 'E'],
  ['JOB-01-012-01', '01-012', 4, 'I', 'E'],
  ['JOB-01-012-02', '01-012', 5, 'T', 'E'],
  ['JOB-01-012-03', '01-012', 6, 'M', 'E'],
  ['JOB-01-012-04', '01-012', 7, 'M', 'E'],
  ['JOB-01-013-01', '01-013', 4, 'I', 'E'],
  ['JOB-01-013-02', '01-013', 5, 'T', 'E'],
  ['JOB-01-013-03', '01-013', 6, 'M', 'E'],
  ['JOB-01-013-04', '01-013', 7, 'M', 'E'],
  ['JOB-01-014-01', '01-014', 4, 'I', 'E'],
  ['JOB-01-014-02', '01-014', 5, 'T', 'E'],
  ['JOB-01-014-03', '01-014', 6, 'M', 'E'],
  ['JOB-01-014-04', '01-014', 7, 'M', 'E'],
  ['JOB-01-015-01', '01-015', 8, 'I', 'E'],
  ['JOB-01-015-02', '01-015', 9, 'T', 'E'],
  ['JOB-01-015-03', '01-015', 10, 'I', 'E'],
  ['JOB-01-015-04', '01-015', 11, 'T', 'E'],
  ['JOB-01-016-01', '01-016', 18, 'I', 'E'],
  ['JOB-01-016-02', '01-016', 19, 'T', 'E'],
  ['JOB-01-016-03', '01-016', 20, 'M', 'E'],
  ['JOB-02-001-01', '02-001', 0, 'I', 'E'],
  ['JOB-02-001-02', '02-001', 1, 'T', 'E'],
  ['JOB-02-001-03', '02-001', 2, 'I', 'E'],
  ['JOB-02-001-04', '02-001', 3, 'I', 'E'],
  ['JOB-02-002-01', '02-002', 0, 'I', 'E'],
  ['JOB-02-002-02', '02-002', 1, 'T', 'E'],
  ['JOB-02-002-03', '02-002', 2, 'I', 'E'],
  ['JOB-02-002-04', '02-002', 3, 'I', 'E'],
  ['JOB-02-003-01', '02-003', 0, 'I', 'E'],
  ['JOB-02-003-02', '02-003', 1, 'T', 'E'],
  ['JOB-02-003-03', '02-003', 2, 'I', 'E'],
  ['JOB-02-003-04', '02-003', 3, 'I', 'E'],
  ['JOB-02-004-01', '02-004', 15, 'I', 'E'],
  ['JOB-02-004-02', '02-004', 16, 'T', 'E'],
  ['JOB-02-004-03', '02-004', 17, 'T', 'E'],
  ['JOB-02-005-01', '02-005', 15, 'I', 'E'],
  ['JOB-02-005-02', '02-005', 16, 'T', 'E'],
  ['JOB-02-005-03', '02-005', 17, 'T', 'E'],
  ['JOB-02-006-01', '02-006', 0, 'I', 'E'],
  ['JOB-02-006-02', '02-006', 1, 'T', 'E'],
  ['JOB-02-006-03', '02-006', 2, 'I', 'E'],
  ['JOB-02-006-04', '02-006', 3, 'I', 'E'],
  ['JOB-02-007-01', '02-007', 4, 'I', 'E'],
  ['JOB-02-007-02', '02-007', 5, 'T', 'E'],
  ['JOB-02-007-03', '02-007', 6, 'M', 'E'],
  ['JOB-02-007-04', '02-007', 7, 'M', 'E'],
  ['JOB-02-008-01', '02-008', 0, 'I', 'E'],
  ['JOB-02-008-02', '02-008', 1, 'T', 'E'],
  ['JOB-02-008-03', '02-008', 2, 'I', 'E'],
  ['JOB-02-008-04', '02-008', 3, 'I', 'E'],
  ['JOB-02-009-01', '02-009', 0, 'I', 'E'],
  ['JOB-02-009-02', '02-009', 1, 'T', 'E'],
  ['JOB-02-009-03', '02-009', 2, 'I', 'E'],
  ['JOB-02-009-04', '02-009', 3, 'I', 'E'],
  ['JOB-02-010-01', '02-010', 0, 'I', 'E'],
  ['JOB-02-010-02', '02-010', 1, 'T', 'E'],
  ['JOB-02-010-03', '02-010', 2, 'I', 'E'],
  ['JOB-02-010-04', '02-010', 3, 'I', 'E'],
  ['JOB-02-011-01', '02-011', 0, 'I', 'E'],
  ['JOB-02-011-02', '02-011', 1, 'T', 'E'],
  ['JOB-02-011-03', '02-011', 2, 'I', 'E'],
  ['JOB-02-011-04', '02-011', 3, 'I', 'E'],
  ['JOB-03-001-01', '03-001', 8, 'I', 'E'],
  ['JOB-03-001-02', '03-001', 9, 'T', 'E'],
  ['JOB-03-001-03', '03-001', 10, 'I', 'E'],
  ['JOB-03-001-04', '03-001', 11, 'T', 'E'],
  ['JOB-03-002-01', '03-002', 8, 'I', 'E'],
  ['JOB-03-002-02', '03-002', 9, 'T', 'E'],
  ['JOB-03-002-03', '03-002', 10, 'I', 'E'],
  ['JOB-03-002-04', '03-002', 11, 'T', 'E'],
  ['JOB-03-003-01', '03-003', 8, 'I', 'E'],
  ['JOB-03-003-02', '03-003', 9, 'T', 'E'],
  ['JOB-03-003-03', '03-003', 10, 'I', 'E'],
  ['JOB-03-003-04', '03-003', 11, 'T', 'E'],
  ['JOB-03-004-01', '03-004', 21, 'I', 'E'],
  ['JOB-03-004-02', '03-004', 22, 'T', 'E'],
  ['JOB-03-004-03', '03-004', 23, 'T', 'E'],
  ['JOB-03-005-01', '03-005', 21, 'I', 'E'],
  ['JOB-03-005-02', '03-005', 22, 'T', 'E'],
  ['JOB-03-005-03', '03-005', 23, 'T', 'E'],
  ['JOB-03-006-01', '03-006', 21, 'I', 'E'],
  ['JOB-03-006-02', '03-006', 22, 'T', 'E'],
  ['JOB-03-006-03', '03-006', 23, 'T', 'E'],
  ['JOB-03-007-01', '03-007', 18, 'I', 'E'],
  ['JOB-03-007-02', '03-007', 19, 'T', 'E'],
  ['JOB-03-007-03', '03-007', 20, 'M', 'E'],
  ['JOB-03-008-01', '03-008', 18, 'I', 'E'],
  ['JOB-03-008-02', '03-008', 19, 'T', 'E'],
  ['JOB-03-008-03', '03-008', 20, 'M', 'E'],
  ['JOB-03-009-01', '03-009', 21, 'I', 'E'],
  ['JOB-03-009-02', '03-009', 22, 'T', 'E'],
  ['JOB-03-009-03', '03-009', 23, 'T', 'E'],
  ['JOB-03-010-01', '03-010', 12, 'I', 'E'],
  ['JOB-03-010-02', '03-010', 13, 'T', 'E'],
  ['JOB-03-010-03', '03-010', 14, 'I', 'E'],
  ['JOB-03-011-01', '03-011', 12, 'I', 'E'],
  ['JOB-03-011-02', '03-011', 13, 'T', 'E'],
  ['JOB-03-011-03', '03-011', 14, 'I', 'E'],
  ['JOB-03-012-01', '03-012', 12, 'I', 'E'],
  ['JOB-03-012-02', '03-012', 13, 'T', 'E'],
  ['JOB-03-012-03', '03-012', 14, 'I', 'E'],
  ['JOB-04-001-01', '04-001', 0, 'I', 'E'],
  ['JOB-04-001-02', '04-001', 1, 'T', 'E'],
  ['JOB-04-001-03', '04-001', 2, 'I', 'E'],
  ['JOB-04-001-04', '04-001', 3, 'I', 'E'],
  ['JOB-04-002-01', '04-002', 21, 'I', 'E'],
  ['JOB-04-002-02', '04-002', 22, 'T', 'E'],
  ['JOB-04-002-03', '04-002', 23, 'T', 'E'],
  ['JOB-04-003-01', '04-003', 21, 'I', 'E'],
  ['JOB-04-003-02', '04-003', 22, 'T', 'E'],
  ['JOB-04-003-03', '04-003', 23, 'T', 'E'],
  ['JOB-04-004-01', '04-004', 21, 'I', 'E'],
  ['JOB-04-004-02', '04-004', 22, 'T', 'E'],
  ['JOB-04-004-03', '04-004', 23, 'T', 'E'],
  ['JOB-04-005-01', '04-005', 8, 'I', 'E'],
  ['JOB-04-005-02', '04-005', 9, 'T', 'E'],
  ['JOB-04-005-03', '04-005', 10, 'I', 'E'],
  ['JOB-04-005-04', '04-005', 11, 'T', 'E'],
  ['JOB-04-006-01', '04-006', 0, 'I', 'E'],
  ['JOB-04-006-02', '04-006', 1, 'T', 'E'],
  ['JOB-04-006-03', '04-006', 2, 'I', 'E'],
  ['JOB-04-006-04', '04-006', 3, 'I', 'E'],
  ['JOB-04-007-01', '04-007', 8, 'I', 'E'],
  ['JOB-04-007-02', '04-007', 9, 'T', 'E'],
  ['JOB-04-007-03', '04-007', 10, 'I', 'E'],
  ['JOB-04-007-04', '04-007', 11, 'T', 'E'],
  ['JOB-04-008-01', '04-008', 4, 'I', 'E'],
  ['JOB-04-008-02', '04-008', 5, 'T', 'E'],
  ['JOB-04-008-03', '04-008', 6, 'M', 'E'],
  ['JOB-04-008-04', '04-008', 7, 'M', 'E'],
  ['JOB-04-009-01', '04-009', 18, 'I', 'E'],
  ['JOB-04-009-02', '04-009', 19, 'T', 'E'],
  ['JOB-04-009-03', '04-009', 20, 'M', 'E'],
  ['JOB-04-010-01', '04-010', 4, 'I', 'E'],
  ['JOB-04-010-02', '04-010', 5, 'T', 'E'],
  ['JOB-04-010-03', '04-010', 6, 'M', 'E'],
  ['JOB-04-010-04', '04-010', 7, 'M', 'E'],
  ['JOB-05-001-01', '05-001', 8, 'I', 'E'],
  ['JOB-05-001-02', '05-001', 9, 'T', 'E'],
  ['JOB-05-001-03', '05-001', 10, 'I', 'E'],
  ['JOB-05-001-04', '05-001', 11, 'T', 'E'],
  ['JOB-05-002-01', '05-002', 8, 'I', 'E'],
  ['JOB-05-002-02', '05-002', 9, 'T', 'E'],
  ['JOB-05-002-03', '05-002', 10, 'I', 'E'],
  ['JOB-05-002-04', '05-002', 11, 'T', 'E'],
  ['JOB-05-003-01', '05-003', 21, 'I', 'E'],
  ['JOB-05-003-02', '05-003', 22, 'T', 'E'],
  ['JOB-05-003-03', '05-003', 23, 'T', 'E'],
  ['JOB-05-004-01', '05-004', 0, 'I', 'E'],
  ['JOB-05-004-02', '05-004', 1, 'T', 'E'],
  ['JOB-05-004-03', '05-004', 2, 'I', 'E'],
  ['JOB-05-004-04', '05-004', 3, 'I', 'E'],
  ['JOB-05-005-01', '05-005', 12, 'I', 'E'],
  ['JOB-05-005-02', '05-005', 13, 'T', 'E'],
  ['JOB-05-005-03', '05-005', 14, 'I', 'E'],
  ['JOB-05-006-01', '05-006', 12, 'I', 'E'],
  ['JOB-05-006-02', '05-006', 13, 'T', 'E'],
  ['JOB-05-006-03', '05-006', 14, 'I', 'E'],
  ['JOB-05-007-01', '05-007', 21, 'I', 'E'],
  ['JOB-05-007-02', '05-007', 22, 'T', 'E'],
  ['JOB-05-007-03', '05-007', 23, 'T', 'E'],
  ['JOB-05-008-01', '05-008', 24, 'I', 'E'],
  ['JOB-05-008-02', '05-008', 25, 'T', 'E'],
  ['JOB-05-008-03', '05-008', 26, 'M', 'E'],
  ['JOB-05-009-01', '05-009', 18, 'I', 'E'],
  ['JOB-05-009-02', '05-009', 19, 'T', 'E'],
  ['JOB-05-009-03', '05-009', 20, 'M', 'E'],
  ['JOB-06-001-01', '06-001', 0, 'I', 'E'],
  ['JOB-06-001-02', '06-001', 1, 'T', 'E'],
  ['JOB-06-001-03', '06-001', 2, 'I', 'E'],
  ['JOB-06-001-04', '06-001', 3, 'I', 'E'],
  ['JOB-06-002-01', '06-002', 0, 'I', 'E'],
  ['JOB-06-002-02', '06-002', 1, 'T', 'E'],
  ['JOB-06-002-03', '06-002', 2, 'I', 'E'],
  ['JOB-06-002-04', '06-002', 3, 'I', 'E'],
  ['JOB-06-003-01', '06-003', 0, 'I', 'E'],
  ['JOB-06-003-02', '06-003', 1, 'T', 'E'],
  ['JOB-06-003-03', '06-003', 2, 'I', 'E'],
  ['JOB-06-003-04', '06-003', 3, 'I', 'E'],
  ['JOB-06-004-01', '06-004', 4, 'I', 'E'],
  ['JOB-06-004-02', '06-004', 5, 'T', 'E'],
  ['JOB-06-004-03', '06-004', 6, 'M', 'E'],
  ['JOB-06-004-04', '06-004', 7, 'M', 'E'],
  ['JOB-06-005-01', '06-005', 21, 'I', 'E'],
  ['JOB-06-005-02', '06-005', 22, 'T', 'E'],
  ['JOB-06-005-03', '06-005', 23, 'T', 'E'],
  ['JOB-06-006-01', '06-006', 12, 'I', 'E'],
  ['JOB-06-006-02', '06-006', 13, 'T', 'E'],
  ['JOB-06-006-03', '06-006', 14, 'I', 'E'],
  ['JOB-06-007-01', '06-007', 12, 'I', 'E'],
  ['JOB-06-007-02', '06-007', 13, 'T', 'E'],
  ['JOB-06-007-03', '06-007', 14, 'I', 'E'],
  ['JOB-06-008-01', '06-008', 4, 'I', 'E'],
  ['JOB-06-008-02', '06-008', 5, 'T', 'E'],
  ['JOB-06-008-03', '06-008', 6, 'M', 'E'],
  ['JOB-06-008-04', '06-008', 7, 'M', 'E'],
  ['JOB-07-001-01', '07-001', 27, 'I', 'E'],
  ['JOB-07-001-02', '07-001', 28, 'T', 'E'],
  ['JOB-07-001-03', '07-001', 29, 'I', 'E'],
  ['JOB-07-002-01', '07-002', 21, 'I', 'E'],
  ['JOB-07-002-02', '07-002', 22, 'T', 'E'],
  ['JOB-07-002-03', '07-002', 23, 'T', 'E'],
  ['JOB-07-003-01', '07-003', 21, 'I', 'E'],
  ['JOB-07-003-02', '07-003', 22, 'T', 'E'],
  ['JOB-07-003-03', '07-003', 23, 'T', 'E'],
  ['JOB-07-004-01', '07-004', 4, 'I', 'E'],
  ['JOB-07-004-02', '07-004', 5, 'T', 'E'],
  ['JOB-07-004-03', '07-004', 6, 'M', 'E'],
  ['JOB-07-004-04', '07-004', 7, 'M', 'E'],
  ['JOB-07-005-01', '07-005', 8, 'I', 'E'],
  ['JOB-07-005-02', '07-005', 9, 'T', 'E'],
  ['JOB-07-005-03', '07-005', 10, 'I', 'E'],
  ['JOB-07-005-04', '07-005', 11, 'T', 'E'],
  ['JOB-07-006-01', '07-006', 21, 'I', 'E'],
  ['JOB-07-006-02', '07-006', 22, 'T', 'E'],
  ['JOB-07-006-03', '07-006', 23, 'T', 'E'],
  ['JOB-07-007-01', '07-007', 4, 'I', 'E'],
  ['JOB-07-007-02', '07-007', 5, 'T', 'E'],
  ['JOB-07-007-03', '07-007', 6, 'M', 'E'],
  ['JOB-07-007-04', '07-007', 7, 'M', 'E'],
  ['JOB-07-008-01', '07-008', 8, 'I', 'E'],
  ['JOB-07-008-02', '07-008', 9, 'T', 'E'],
  ['JOB-07-008-03', '07-008', 10, 'I', 'E'],
  ['JOB-07-008-04', '07-008', 11, 'T', 'E'],
  ['JOB-07-009-01', '07-009', 12, 'I', 'E'],
  ['JOB-07-009-02', '07-009', 13, 'T', 'E'],
  ['JOB-07-009-03', '07-009', 14, 'I', 'E'],
  ['JOB-07-010-01', '07-010', 18, 'I', 'E'],
  ['JOB-07-010-02', '07-010', 19, 'T', 'E'],
  ['JOB-07-010-03', '07-010', 20, 'M', 'E'],
  ['JOB-08-001-01', '08-001', 15, 'I', 'E'],
  ['JOB-08-001-02', '08-001', 16, 'T', 'E'],
  ['JOB-08-001-03', '08-001', 17, 'T', 'E'],
  ['JOB-08-002-01', '08-002', 15, 'I', 'E'],
  ['JOB-08-002-02', '08-002', 16, 'T', 'E'],
  ['JOB-08-002-03', '08-002', 17, 'T', 'E'],
  ['JOB-08-003-01', '08-003', 15, 'I', 'E'],
  ['JOB-08-003-02', '08-003', 16, 'T', 'E'],
  ['JOB-08-003-03', '08-003', 17, 'T', 'E'],
  ['JOB-08-004-01', '08-004', 15, 'I', 'E'],
  ['JOB-08-004-02', '08-004', 16, 'T', 'E'],
  ['JOB-08-004-03', '08-004', 17, 'T', 'E'],
  ['JOB-08-005-01', '08-005', 15, 'I', 'E'],
  ['JOB-08-005-02', '08-005', 16, 'T', 'E'],
  ['JOB-08-005-03', '08-005', 17, 'T', 'E'],
  ['JOB-08-006-01', '08-006', 15, 'I', 'E'],
  ['JOB-08-006-02', '08-006', 16, 'T', 'E'],
  ['JOB-08-006-03', '08-006', 17, 'T', 'E'],
  ['JOB-08-007-01', '08-007', 15, 'I', 'E'],
  ['JOB-08-007-02', '08-007', 16, 'T', 'E'],
  ['JOB-08-007-03', '08-007', 17, 'T', 'E'],
  ['JOB-08-008-01', '08-008', 18, 'I', 'E'],
  ['JOB-08-008-02', '08-008', 19, 'T', 'E'],
  ['JOB-08-008-03', '08-008', 20, 'M', 'E'],
  ['JOB-08-009-01', '08-009', 4, 'I', 'E'],
  ['JOB-08-009-02', '08-009', 5, 'T', 'E'],
  ['JOB-08-009-03', '08-009', 6, 'M', 'E'],
  ['JOB-08-009-04', '08-009', 7, 'M', 'E'],
  ['JOB-08-010-01', '08-010', 18, 'I', 'E'],
  ['JOB-08-010-02', '08-010', 19, 'T', 'E'],
  ['JOB-08-010-03', '08-010', 20, 'M', 'E'],
  ['JOB-08-011-01', '08-011', 0, 'I', 'E'],
  ['JOB-08-011-02', '08-011', 1, 'T', 'E'],
  ['JOB-08-011-03', '08-011', 2, 'I', 'E'],
  ['JOB-08-011-04', '08-011', 3, 'I', 'E'],
  ['JOB-08-012-01', '08-012', 0, 'I', 'E'],
  ['JOB-08-012-02', '08-012', 1, 'T', 'E'],
  ['JOB-08-012-03', '08-012', 2, 'I', 'E'],
  ['JOB-08-012-04', '08-012', 3, 'I', 'E'],
  ['JOB-08-013-01', '08-013', 18, 'I', 'E'],
  ['JOB-08-013-02', '08-013', 19, 'T', 'E'],
  ['JOB-08-013-03', '08-013', 20, 'M', 'E'],
  ['JOB-08-014-01', '08-014', 4, 'I', 'E'],
  ['JOB-08-014-02', '08-014', 5, 'T', 'E'],
  ['JOB-08-014-03', '08-014', 6, 'M', 'E'],
  ['JOB-08-014-04', '08-014', 7, 'M', 'E'],
  ['JOB-09-001-01', '09-001', 4, 'I', 'E'],
  ['JOB-09-001-02', '09-001', 5, 'T', 'E'],
  ['JOB-09-001-03', '09-001', 6, 'M', 'E'],
  ['JOB-09-001-04', '09-001', 7, 'M', 'E'],
  ['JOB-09-002-01', '09-002', 8, 'I', 'E'],
  ['JOB-09-002-02', '09-002', 9, 'T', 'E'],
  ['JOB-09-002-03', '09-002', 10, 'I', 'E'],
  ['JOB-09-002-04', '09-002', 11, 'T', 'E'],
  ['JOB-09-003-01', '09-003', 4, 'I', 'E'],
  ['JOB-09-003-02', '09-003', 5, 'T', 'E'],
  ['JOB-09-003-03', '09-003', 6, 'M', 'E'],
  ['JOB-09-003-04', '09-003', 7, 'M', 'E'],
  ['JOB-09-004-01', '09-004', 4, 'I', 'E'],
  ['JOB-09-004-02', '09-004', 5, 'T', 'E'],
  ['JOB-09-004-03', '09-004', 6, 'M', 'E'],
  ['JOB-09-004-04', '09-004', 7, 'M', 'E'],
  ['JOB-09-005-01', '09-005', 4, 'I', 'E'],
  ['JOB-09-005-02', '09-005', 5, 'T', 'E'],
  ['JOB-09-005-03', '09-005', 6, 'M', 'E'],
  ['JOB-09-005-04', '09-005', 7, 'M', 'E'],
  ['JOB-09-006-01', '09-006', 4, 'I', 'E'],
  ['JOB-09-006-02', '09-006', 5, 'T', 'E'],
  ['JOB-09-006-03', '09-006', 6, 'M', 'E'],
  ['JOB-09-006-04', '09-006', 7, 'M', 'E'],
  ['JOB-09-007-01', '09-007', 18, 'I', 'E'],
  ['JOB-09-007-02', '09-007', 19, 'T', 'E'],
  ['JOB-09-007-03', '09-007', 20, 'M', 'E'],
  ['JOB-09-008-01', '09-008', 18, 'I', 'E'],
  ['JOB-09-008-02', '09-008', 19, 'T', 'E'],
  ['JOB-09-008-03', '09-008', 20, 'M', 'E'],
  ['JOB-10-001-01', '10-001', 8, 'I', 'E'],
  ['JOB-10-001-02', '10-001', 9, 'T', 'E'],
  ['JOB-10-001-03', '10-001', 10, 'I', 'E'],
  ['JOB-10-001-04', '10-001', 11, 'T', 'E'],
  ['JOB-10-002-01', '10-002', 8, 'I', 'E'],
  ['JOB-10-002-02', '10-002', 9, 'T', 'E'],
  ['JOB-10-002-03', '10-002', 10, 'I', 'E'],
  ['JOB-10-002-04', '10-002', 11, 'T', 'E'],
  ['JOB-10-003-01', '10-003', 8, 'I', 'E'],
  ['JOB-10-003-02', '10-003', 9, 'T', 'E'],
  ['JOB-10-003-03', '10-003', 10, 'I', 'E'],
  ['JOB-10-003-04', '10-003', 11, 'T', 'E'],
  ['JOB-10-004-01', '10-004', 4, 'I', 'E'],
  ['JOB-10-004-02', '10-004', 5, 'T', 'E'],
  ['JOB-10-004-03', '10-004', 6, 'M', 'E'],
  ['JOB-10-004-04', '10-004', 7, 'M', 'E'],
  ['JOB-10-005-01', '10-005', 12, 'I', 'E'],
  ['JOB-10-005-02', '10-005', 13, 'T', 'E'],
  ['JOB-10-005-03', '10-005', 14, 'I', 'E'],
  ['JOB-10-006-01', '10-006', 18, 'I', 'E'],
  ['JOB-10-006-02', '10-006', 19, 'T', 'E'],
  ['JOB-10-006-03', '10-006', 20, 'M', 'E'],
  ['JOB-10-007-01', '10-007', 24, 'I', 'E'],
  ['JOB-10-007-02', '10-007', 25, 'T', 'E'],
  ['JOB-10-007-03', '10-007', 26, 'M', 'E'],
  ['JOB-10-008-01', '10-008', 4, 'I', 'E'],
  ['JOB-10-008-02', '10-008', 5, 'T', 'E'],
  ['JOB-10-008-03', '10-008', 6, 'M', 'E'],
  ['JOB-10-008-04', '10-008', 7, 'M', 'E'],
  ['JOB-10-009-01', '10-009', 15, 'I', 'E'],
  ['JOB-10-009-02', '10-009', 16, 'T', 'E'],
  ['JOB-10-009-03', '10-009', 17, 'T', 'E'],
  ['JOB-11-001-01', '11-001', 0, 'I', 'E'],
  ['JOB-11-001-02', '11-001', 1, 'T', 'E'],
  ['JOB-11-001-03', '11-001', 2, 'I', 'E'],
  ['JOB-11-001-04', '11-001', 3, 'I', 'E'],
  ['JOB-11-002-01', '11-002', 8, 'I', 'E'],
  ['JOB-11-002-02', '11-002', 9, 'T', 'E'],
  ['JOB-11-002-03', '11-002', 10, 'I', 'E'],
  ['JOB-11-002-04', '11-002', 11, 'T', 'E'],
  ['JOB-11-003-01', '11-003', 21, 'I', 'E'],
  ['JOB-11-003-02', '11-003', 22, 'T', 'E'],
  ['JOB-11-003-03', '11-003', 23, 'T', 'E'],
  ['JOB-11-004-01', '11-004', 8, 'I', 'E'],
  ['JOB-11-004-02', '11-004', 9, 'T', 'E'],
  ['JOB-11-004-03', '11-004', 10, 'I', 'E'],
  ['JOB-11-004-04', '11-004', 11, 'T', 'E'],
  ['JOB-11-005-01', '11-005', 21, 'I', 'E'],
  ['JOB-11-005-02', '11-005', 22, 'T', 'E'],
  ['JOB-11-005-03', '11-005', 23, 'T', 'E'],
  ['JOB-11-006-01', '11-006', 8, 'I', 'E'],
  ['JOB-11-006-02', '11-006', 9, 'T', 'E'],
  ['JOB-11-006-03', '11-006', 10, 'I', 'E'],
  ['JOB-11-006-04', '11-006', 11, 'T', 'E'],
  ['JOB-11-007-01', '11-007', 8, 'I', 'E'],
  ['JOB-11-007-02', '11-007', 9, 'T', 'E'],
  ['JOB-11-007-03', '11-007', 10, 'I', 'E'],
  ['JOB-11-007-04', '11-007', 11, 'T', 'E'],
  ['JOB-11-008-01', '11-008', 24, 'I', 'E'],
  ['JOB-11-008-02', '11-008', 25, 'T', 'E'],
  ['JOB-11-008-03', '11-008', 26, 'M', 'E'],
  ['JOB-11-009-01', '11-009', 24, 'I', 'E'],
  ['JOB-11-009-02', '11-009', 25, 'T', 'E'],
  ['JOB-11-009-03', '11-009', 26, 'M', 'E'],
  ['JOB-12-001-01', '12-001', 30, 'I', 'D'],
  ['JOB-12-001-02', '12-001', 31, 'T', 'D'],
  ['JOB-12-001-03', '12-001', 32, 'I', 'D'],
  ['JOB-12-002-01', '12-002', 4, 'I', 'D'],
  ['JOB-12-002-02', '12-002', 5, 'T', 'D'],
  ['JOB-12-002-03', '12-002', 6, 'M', 'D'],
  ['JOB-12-002-04', '12-002', 7, 'M', 'D'],
  ['JOB-12-003-01', '12-003', 30, 'I', 'D'],
  ['JOB-12-003-02', '12-003', 31, 'T', 'D'],
  ['JOB-12-003-03', '12-003', 32, 'I', 'D'],
  ['JOB-12-004-01', '12-004', 30, 'I', 'D'],
  ['JOB-12-004-02', '12-004', 31, 'T', 'D'],
  ['JOB-12-004-03', '12-004', 32, 'I', 'D'],
  ['JOB-12-005-01', '12-005', 30, 'I', 'D'],
  ['JOB-12-005-02', '12-005', 31, 'T', 'D'],
  ['JOB-12-005-03', '12-005', 32, 'I', 'D'],
  ['JOB-12-006-01', '12-006', 24, 'I', 'D'],
  ['JOB-12-006-02', '12-006', 25, 'T', 'D'],
  ['JOB-12-006-03', '12-006', 26, 'M', 'D'],
  ['JOB-12-007-01', '12-007', 24, 'I', 'D'],
  ['JOB-12-007-02', '12-007', 25, 'T', 'D'],
  ['JOB-12-007-03', '12-007', 26, 'M', 'D'],
  ['JOB-12-008-01', '12-008', 30, 'I', 'D'],
  ['JOB-12-008-02', '12-008', 31, 'T', 'D'],
  ['JOB-12-008-03', '12-008', 32, 'I', 'D'],
  ['JOB-12-009-01', '12-009', 30, 'I', 'D'],
  ['JOB-12-009-02', '12-009', 31, 'T', 'D'],
  ['JOB-12-009-03', '12-009', 32, 'I', 'D'],
  ['JOB-12-010-01', '12-010', 30, 'I', 'D'],
  ['JOB-12-010-02', '12-010', 31, 'T', 'D'],
  ['JOB-12-010-03', '12-010', 32, 'I', 'D'],
  ['JOB-12-011-01', '12-011', 12, 'I', 'D'],
  ['JOB-12-011-02', '12-011', 13, 'T', 'D'],
  ['JOB-12-011-03', '12-011', 14, 'I', 'D'],
  ['JOB-13-001-01', '13-001', 30, 'I', 'D'],
  ['JOB-13-001-02', '13-001', 31, 'T', 'D'],
  ['JOB-13-001-03', '13-001', 32, 'I', 'D'],
  ['JOB-13-002-01', '13-002', 12, 'I', 'D'],
  ['JOB-13-002-02', '13-002', 13, 'T', 'D'],
  ['JOB-13-002-03', '13-002', 14, 'I', 'D'],
  ['JOB-13-003-01', '13-003', 18, 'I', 'D'],
  ['JOB-13-003-02', '13-003', 19, 'T', 'D'],
  ['JOB-13-003-03', '13-003', 20, 'M', 'D'],
  ['JOB-13-004-01', '13-004', 18, 'I', 'D'],
  ['JOB-13-004-02', '13-004', 19, 'T', 'D'],
  ['JOB-13-004-03', '13-004', 20, 'M', 'D'],
  ['JOB-13-005-01', '13-005', 8, 'I', 'D'],
  ['JOB-13-005-02', '13-005', 9, 'T', 'D'],
  ['JOB-13-005-03', '13-005', 10, 'I', 'D'],
  ['JOB-13-005-04', '13-005', 11, 'T', 'D'],
  ['JOB-13-006-01', '13-006', 12, 'I', 'D'],
  ['JOB-13-006-02', '13-006', 13, 'T', 'D'],
  ['JOB-13-006-03', '13-006', 14, 'I', 'D'],
  ['JOB-13-007-01', '13-007', 24, 'I', 'D'],
  ['JOB-13-007-02', '13-007', 25, 'T', 'D'],
  ['JOB-13-007-03', '13-007', 26, 'M', 'D'],
  ['JOB-13-008-01', '13-008', 24, 'I', 'D'],
  ['JOB-13-008-02', '13-008', 25, 'T', 'D'],
  ['JOB-13-008-03', '13-008', 26, 'M', 'D'],
  ['JOB-13-009-01', '13-009', 24, 'I', 'D'],
  ['JOB-13-009-02', '13-009', 25, 'T', 'D'],
  ['JOB-13-009-03', '13-009', 26, 'M', 'D'],
  ['JOB-13-010-01', '13-010', 24, 'I', 'D'],
  ['JOB-13-010-02', '13-010', 25, 'T', 'D'],
  ['JOB-13-010-03', '13-010', 26, 'M', 'D'],
  ['JOB-13-011-01', '13-011', 0, 'I', 'D'],
  ['JOB-13-011-02', '13-011', 1, 'T', 'D'],
  ['JOB-13-011-03', '13-011', 2, 'I', 'D'],
  ['JOB-13-011-04', '13-011', 3, 'I', 'D'],
  ['JOB-13-012-01', '13-012', 24, 'I', 'D'],
  ['JOB-13-012-02', '13-012', 25, 'T', 'D'],
  ['JOB-13-012-03', '13-012', 26, 'M', 'D'],
  ['JOB-13-013-01', '13-013', 30, 'I', 'D'],
  ['JOB-13-013-02', '13-013', 31, 'T', 'D'],
  ['JOB-13-013-03', '13-013', 32, 'I', 'D'],
  ['JOB-13-014-01', '13-014', 30, 'I', 'D'],
  ['JOB-13-014-02', '13-014', 31, 'T', 'D'],
  ['JOB-13-014-03', '13-014', 32, 'I', 'D'],
  ['JOB-14-001-01', '14-001', 33, 'T', 'D'],
  ['JOB-14-001-02', '14-001', 34, 'I', 'D'],
  ['JOB-14-001-03', '14-001', 35, 'T', 'D'],
  ['JOB-14-002-01', '14-002', 33, 'T', 'D'],
  ['JOB-14-002-02', '14-002', 34, 'I', 'D'],
  ['JOB-14-002-03', '14-002', 35, 'T', 'D'],
  ['JOB-14-003-01', '14-003', 33, 'T', 'D'],
  ['JOB-14-003-02', '14-003', 34, 'I', 'D'],
  ['JOB-14-003-03', '14-003', 35, 'T', 'D'],
  ['JOB-14-004-01', '14-004', 33, 'T', 'D'],
  ['JOB-14-004-02', '14-004', 34, 'I', 'D'],
  ['JOB-14-004-03', '14-004', 35, 'T', 'D'],
  ['JOB-14-005-01', '14-005', 33, 'T', 'D'],
  ['JOB-14-005-02', '14-005', 34, 'I', 'D'],
  ['JOB-14-005-03', '14-005', 35, 'T', 'D'],
  ['JOB-14-006-01', '14-006', 33, 'T', 'D'],
  ['JOB-14-006-02', '14-006', 34, 'I', 'D'],
  ['JOB-14-006-03', '14-006', 35, 'T', 'D'],
  ['JOB-14-007-01', '14-007', 33, 'T', 'D'],
  ['JOB-14-007-02', '14-007', 34, 'I', 'D'],
  ['JOB-14-007-03', '14-007', 35, 'T', 'D'],
  ['JOB-14-008-01', '14-008', 4, 'I', 'D'],
  ['JOB-14-008-02', '14-008', 5, 'T', 'D'],
  ['JOB-14-008-03', '14-008', 6, 'M', 'D'],
  ['JOB-14-008-04', '14-008', 7, 'M', 'D'],
  ['JOB-14-009-01', '14-009', 33, 'T', 'D'],
  ['JOB-14-009-02', '14-009', 34, 'I', 'D'],
  ['JOB-14-009-03', '14-009', 35, 'T', 'D'],
  ['JOB-14-010-01', '14-010', 33, 'T', 'D'],
  ['JOB-14-010-02', '14-010', 34, 'I', 'D'],
  ['JOB-14-010-03', '14-010', 35, 'T', 'D'],
  ['JOB-14-011-01', '14-011', 33, 'T', 'D'],
  ['JOB-14-011-02', '14-011', 34, 'I', 'D'],
  ['JOB-14-011-03', '14-011', 35, 'T', 'D'],
  ['JOB-14-012-01', '14-012', 18, 'I', 'D'],
  ['JOB-14-012-02', '14-012', 19, 'T', 'D'],
  ['JOB-14-012-03', '14-012', 20, 'M', 'D'],
  ['JOB-14-013-01', '14-013', 4, 'I', 'D'],
  ['JOB-14-013-02', '14-013', 5, 'T', 'D'],
  ['JOB-14-013-03', '14-013', 6, 'M', 'D'],
  ['JOB-14-013-04', '14-013', 7, 'M', 'D'],
  ['JOB-14-014-01', '14-014', 18, 'I', 'D'],
  ['JOB-14-014-02', '14-014', 19, 'T', 'D'],
  ['JOB-14-014-03', '14-014', 20, 'M', 'D'],
  ['JOB-14-015-01', '14-015', 18, 'I', 'D'],
  ['JOB-14-015-02', '14-015', 19, 'T', 'D'],
  ['JOB-14-015-03', '14-015', 20, 'M', 'D'],
  ['JOB-15-001-01', '15-001', 33, 'T', 'D'],
  ['JOB-15-001-02', '15-001', 34, 'I', 'D'],
  ['JOB-15-001-03', '15-001', 35, 'T', 'D'],
  ['JOB-15-002-01', '15-002', 33, 'T', 'D'],
  ['JOB-15-002-02', '15-002', 34, 'I', 'D'],
  ['JOB-15-002-03', '15-002', 35, 'T', 'D'],
  ['JOB-15-003-01', '15-003', 33, 'T', 'D'],
  ['JOB-15-003-02', '15-003', 34, 'I', 'D'],
  ['JOB-15-003-03', '15-003', 35, 'T', 'D'],
  ['JOB-15-004-01', '15-004', 33, 'T', 'D'],
  ['JOB-15-004-02', '15-004', 34, 'I', 'D'],
  ['JOB-15-004-03', '15-004', 35, 'T', 'D'],
  ['JOB-15-005-01', '15-005', 33, 'T', 'D'],
  ['JOB-15-005-02', '15-005', 34, 'I', 'D'],
  ['JOB-15-005-03', '15-005', 35, 'T', 'D'],
  ['JOB-15-006-01', '15-006', 33, 'T', 'D'],
  ['JOB-15-006-02', '15-006', 34, 'I', 'D'],
  ['JOB-15-006-03', '15-006', 35, 'T', 'D'],
  ['JOB-15-007-01', '15-007', 33, 'T', 'D'],
  ['JOB-15-007-02', '15-007', 34, 'I', 'D'],
  ['JOB-15-007-03', '15-007', 35, 'T', 'D'],
  ['JOB-15-008-01', '15-008', 15, 'I', 'D'],
  ['JOB-15-008-02', '15-008', 16, 'T', 'D'],
  ['JOB-15-008-03', '15-008', 17, 'T', 'D'],
  ['JOB-15-009-01', '15-009', 4, 'I', 'D'],
  ['JOB-15-009-02', '15-009', 5, 'T', 'D'],
  ['JOB-15-009-03', '15-009', 6, 'M', 'D'],
  ['JOB-15-009-04', '15-009', 7, 'M', 'D'],
  ['JOB-15-010-01', '15-010', 18, 'I', 'D'],
  ['JOB-15-010-02', '15-010', 19, 'T', 'D'],
  ['JOB-15-010-03', '15-010', 20, 'M', 'D'],
  ['JOB-15-011-01', '15-011', 4, 'I', 'D'],
  ['JOB-15-011-02', '15-011', 5, 'T', 'D'],
  ['JOB-15-011-03', '15-011', 6, 'M', 'D'],
  ['JOB-15-011-04', '15-011', 7, 'M', 'D'],
  ['JOB-15-012-01', '15-012', 4, 'I', 'D'],
  ['JOB-15-012-02', '15-012', 5, 'T', 'D'],
  ['JOB-15-012-03', '15-012', 6, 'M', 'D'],
  ['JOB-15-012-04', '15-012', 7, 'M', 'D'],
  ['JOB-15-013-01', '15-013', 4, 'I', 'D'],
  ['JOB-15-013-02', '15-013', 5, 'T', 'D'],
  ['JOB-15-013-03', '15-013', 6, 'M', 'D'],
  ['JOB-15-013-04', '15-013', 7, 'M', 'D'],
  ['JOB-16-001-01', '16-001', 8, 'I', 'D'],
  ['JOB-16-001-02', '16-001', 9, 'T', 'D'],
  ['JOB-16-001-03', '16-001', 10, 'I', 'D'],
  ['JOB-16-001-04', '16-001', 11, 'T', 'D'],
  ['JOB-16-002-01', '16-002', 8, 'I', 'D'],
  ['JOB-16-002-02', '16-002', 9, 'T', 'D'],
  ['JOB-16-002-03', '16-002', 10, 'I', 'D'],
  ['JOB-16-002-04', '16-002', 11, 'T', 'D'],
  ['JOB-16-003-01', '16-003', 12, 'I', 'D'],
  ['JOB-16-003-02', '16-003', 13, 'T', 'D'],
  ['JOB-16-003-03', '16-003', 14, 'I', 'D'],
  ['JOB-16-004-01', '16-004', 15, 'I', 'D'],
  ['JOB-16-004-02', '16-004', 16, 'T', 'D'],
  ['JOB-16-004-03', '16-004', 17, 'T', 'D'],
  ['JOB-16-005-01', '16-005', 18, 'I', 'D'],
  ['JOB-16-005-02', '16-005', 19, 'T', 'D'],
  ['JOB-16-005-03', '16-005', 20, 'M', 'D'],
  ['JOB-16-006-01', '16-006', 18, 'I', 'D'],
  ['JOB-16-006-02', '16-006', 19, 'T', 'D'],
  ['JOB-16-006-03', '16-006', 20, 'M', 'D'],
  ['JOB-16-007-01', '16-007', 27, 'I', 'D'],
  ['JOB-16-007-02', '16-007', 28, 'T', 'D'],
  ['JOB-16-007-03', '16-007', 29, 'I', 'D'],
  ['JOB-16-008-01', '16-008', 8, 'I', 'D'],
  ['JOB-16-008-02', '16-008', 9, 'T', 'D'],
  ['JOB-16-008-03', '16-008', 10, 'I', 'D'],
  ['JOB-16-008-04', '16-008', 11, 'T', 'D'],
  ['JOB-16-009-01', '16-009', 27, 'I', 'D'],
  ['JOB-16-009-02', '16-009', 28, 'T', 'D'],
  ['JOB-16-009-03', '16-009', 29, 'I', 'D'],
  ['JOB-16-010-01', '16-010', 12, 'I', 'D'],
  ['JOB-16-010-02', '16-010', 13, 'T', 'D'],
  ['JOB-16-010-03', '16-010', 14, 'I', 'D'],
  ['JOB-16-011-01', '16-011', 8, 'I', 'D'],
  ['JOB-16-011-02', '16-011', 9, 'T', 'D'],
  ['JOB-16-011-03', '16-011', 10, 'I', 'D'],
  ['JOB-16-011-04', '16-011', 11, 'T', 'D'],
  ['JOB-16-012-01', '16-012', 12, 'I', 'D'],
  ['JOB-16-012-02', '16-012', 13, 'T', 'D'],
  ['JOB-16-012-03', '16-012', 14, 'I', 'D'],
  ['JOB-16-013-01', '16-013', 27, 'I', 'D'],
  ['JOB-16-013-02', '16-013', 28, 'T', 'D'],
  ['JOB-16-013-03', '16-013', 29, 'I', 'D'],
  ['JOB-16-014-01', '16-014', 27, 'I', 'D'],
  ['JOB-16-014-02', '16-014', 28, 'T', 'D'],
  ['JOB-16-014-03', '16-014', 29, 'I', 'D'],
  ['JOB-16-015-01', '16-015', 4, 'I', 'D'],
  ['JOB-16-015-02', '16-015', 5, 'T', 'D'],
  ['JOB-16-015-03', '16-015', 6, 'M', 'D'],
  ['JOB-16-015-04', '16-015', 7, 'M', 'D'],
  ['JOB-17-001-01', '17-001', 27, 'I', 'D'],
  ['JOB-17-001-02', '17-001', 28, 'T', 'D'],
  ['JOB-17-001-03', '17-001', 29, 'I', 'D'],
  ['JOB-17-002-01', '17-002', 0, 'I', 'D'],
  ['JOB-17-002-02', '17-002', 1, 'T', 'D'],
  ['JOB-17-002-03', '17-002', 2, 'I', 'D'],
  ['JOB-17-002-04', '17-002', 3, 'I', 'D'],
  ['JOB-17-003-01', '17-003', 27, 'I', 'D'],
  ['JOB-17-003-02', '17-003', 28, 'T', 'D'],
  ['JOB-17-003-03', '17-003', 29, 'I', 'D'],
  ['JOB-17-004-01', '17-004', 0, 'I', 'D'],
  ['JOB-17-004-02', '17-004', 1, 'T', 'D'],
  ['JOB-17-004-03', '17-004', 2, 'I', 'D'],
  ['JOB-17-004-04', '17-004', 3, 'I', 'D'],
  ['JOB-17-005-01', '17-005', 27, 'I', 'D'],
  ['JOB-17-005-02', '17-005', 28, 'T', 'D'],
  ['JOB-17-005-03', '17-005', 29, 'I', 'D'],
  ['JOB-17-006-01', '17-006', 4, 'I', 'D'],
  ['JOB-17-006-02', '17-006', 5, 'T', 'D'],
  ['JOB-17-006-03', '17-006', 6, 'M', 'D'],
  ['JOB-17-006-04', '17-006', 7, 'M', 'D'],
  ['JOB-17-007-01', '17-007', 27, 'I', 'D'],
  ['JOB-17-007-02', '17-007', 28, 'T', 'D'],
  ['JOB-17-007-03', '17-007', 29, 'I', 'D'],
  ['JOB-17-008-01', '17-008', 27, 'I', 'D'],
  ['JOB-17-008-02', '17-008', 28, 'T', 'D'],
  ['JOB-17-008-03', '17-008', 29, 'I', 'D'],
  ['JOB-17-009-01', '17-009', 27, 'I', 'D'],
  ['JOB-17-009-02', '17-009', 28, 'T', 'D'],
  ['JOB-17-009-03', '17-009', 29, 'I', 'D'],
  ['JOB-17-010-01', '17-010', 4, 'I', 'D'],
  ['JOB-17-010-02', '17-010', 5, 'T', 'D'],
  ['JOB-17-010-03', '17-010', 6, 'M', 'D'],
  ['JOB-17-010-04', '17-010', 7, 'M', 'D'],
  ['JOB-17-011-01', '17-011', 27, 'I', 'D'],
  ['JOB-17-011-02', '17-011', 28, 'T', 'D'],
  ['JOB-17-011-03', '17-011', 29, 'I', 'D'],
  ['JOB-17-012-01', '17-012', 4, 'I', 'D'],
  ['JOB-17-012-02', '17-012', 5, 'T', 'D'],
  ['JOB-17-012-03', '17-012', 6, 'M', 'D'],
  ['JOB-17-012-04', '17-012', 7, 'M', 'D'],
  ['JOB-18-001-01', '18-001', 24, 'I', 'D'],
  ['JOB-18-001-02', '18-001', 25, 'T', 'D'],
  ['JOB-18-001-03', '18-001', 26, 'M', 'D'],
  ['JOB-18-002-01', '18-002', 24, 'I', 'D'],
  ['JOB-18-002-02', '18-002', 25, 'T', 'D'],
  ['JOB-18-002-03', '18-002', 26, 'M', 'D'],
  ['JOB-18-003-01', '18-003', 24, 'I', 'D'],
  ['JOB-18-003-02', '18-003', 25, 'T', 'D'],
  ['JOB-18-003-03', '18-003', 26, 'M', 'D'],
  ['JOB-18-004-01', '18-004', 12, 'I', 'D'],
  ['JOB-18-004-02', '18-004', 13, 'T', 'D'],
  ['JOB-18-004-03', '18-004', 14, 'I', 'D'],
  ['JOB-18-005-01', '18-005', 12, 'I', 'D'],
  ['JOB-18-005-02', '18-005', 13, 'T', 'D'],
  ['JOB-18-005-03', '18-005', 14, 'I', 'D'],
  ['JOB-18-006-01', '18-006', 24, 'I', 'D'],
  ['JOB-18-006-02', '18-006', 25, 'T', 'D'],
  ['JOB-18-006-03', '18-006', 26, 'M', 'D'],
  ['JOB-18-007-01', '18-007', 24, 'I', 'D'],
  ['JOB-18-007-02', '18-007', 25, 'T', 'D'],
  ['JOB-18-007-03', '18-007', 26, 'M', 'D'],
  ['JOB-18-008-01', '18-008', 12, 'I', 'D'],
  ['JOB-18-008-02', '18-008', 13, 'T', 'D'],
  ['JOB-18-008-03', '18-008', 14, 'I', 'D'],
  ['JOB-18-009-01', '18-009', 4, 'I', 'D'],
  ['JOB-18-009-02', '18-009', 5, 'T', 'D'],
  ['JOB-18-009-03', '18-009', 6, 'M', 'D'],
  ['JOB-18-009-04', '18-009', 7, 'M', 'D'],
  ['JOB-18-010-01', '18-010', 24, 'I', 'D'],
  ['JOB-18-010-02', '18-010', 25, 'T', 'D'],
  ['JOB-18-010-03', '18-010', 26, 'M', 'D'],
  ['JOB-18-011-01', '18-011', 12, 'I', 'D'],
  ['JOB-18-011-02', '18-011', 13, 'T', 'D'],
  ['JOB-18-011-03', '18-011', 14, 'I', 'D'],
  ['JOB-18-012-01', '18-012', 24, 'I', 'D'],
  ['JOB-18-012-02', '18-012', 25, 'T', 'D'],
  ['JOB-18-012-03', '18-012', 26, 'M', 'D'],
  ['JOB-19-001-01', '19-001', 0, 'I', ''],
  ['JOB-19-001-02', '19-001', 1, 'T', ''],
  ['JOB-19-001-03', '19-001', 2, 'I', ''],
  ['JOB-19-001-04', '19-001', 3, 'I', ''],
  ['JOB-19-002-01', '19-002', 8, 'I', ''],
  ['JOB-19-002-02', '19-002', 9, 'T', ''],
  ['JOB-19-002-03', '19-002', 10, 'I', ''],
  ['JOB-19-002-04', '19-002', 11, 'T', ''],
  ['JOB-19-003-01', '19-003', 4, 'I', ''],
  ['JOB-19-003-02', '19-003', 5, 'T', ''],
  ['JOB-19-003-03', '19-003', 6, 'M', ''],
  ['JOB-19-003-04', '19-003', 7, 'M', ''],
  ['JOB-19-004-01', '19-004', 18, 'I', ''],
  ['JOB-19-004-02', '19-004', 19, 'T', ''],
  ['JOB-19-004-03', '19-004', 20, 'M', ''],
  ['JOB-19-005-01', '19-005', 4, 'I', ''],
  ['JOB-19-005-02', '19-005', 5, 'T', ''],
  ['JOB-19-005-03', '19-005', 6, 'M', ''],
  ['JOB-19-005-04', '19-005', 7, 'M', ''],
  ['JOB-19-006-01', '19-006', 4, 'I', ''],
  ['JOB-19-006-02', '19-006', 5, 'T', ''],
  ['JOB-19-006-03', '19-006', 6, 'M', ''],
  ['JOB-19-006-04', '19-006', 7, 'M', ''],
  ['JOB-19-007-01', '19-007', 4, 'I', ''],
  ['JOB-19-007-02', '19-007', 5, 'T', ''],
  ['JOB-19-007-03', '19-007', 6, 'M', ''],
  ['JOB-19-007-04', '19-007', 7, 'M', ''],
  ['JOB-19-008-01', '19-008', 4, 'I', ''],
  ['JOB-19-008-02', '19-008', 5, 'T', ''],
  ['JOB-19-008-03', '19-008', 6, 'M', ''],
  ['JOB-19-008-04', '19-008', 7, 'M', ''],
  ['JOB-19-009-01', '19-009', 8, 'I', ''],
  ['JOB-19-009-02', '19-009', 9, 'T', ''],
  ['JOB-19-009-03', '19-009', 10, 'I', ''],
  ['JOB-19-009-04', '19-009', 11, 'T', ''],
  ['JOB-19-010-01', '19-010', 4, 'I', ''],
  ['JOB-19-010-02', '19-010', 5, 'T', ''],
  ['JOB-19-010-03', '19-010', 6, 'M', ''],
  ['JOB-19-010-04', '19-010', 7, 'M', ''],
  ['JOB-20-001-01', '20-001', 21, 'I', ''],
  ['JOB-20-001-02', '20-001', 22, 'T', ''],
  ['JOB-20-001-03', '20-001', 23, 'T', ''],
  ['JOB-20-002-01', '20-002', 18, 'I', ''],
  ['JOB-20-002-02', '20-002', 19, 'T', ''],
  ['JOB-20-002-03', '20-002', 20, 'M', ''],
  ['JOB-20-003-01', '20-003', 8, 'I', ''],
  ['JOB-20-003-02', '20-003', 9, 'T', ''],
  ['JOB-20-003-03', '20-003', 10, 'I', ''],
  ['JOB-20-003-04', '20-003', 11, 'T', ''],
  ['JOB-20-004-01', '20-004', 21, 'I', ''],
  ['JOB-20-004-02', '20-004', 22, 'T', ''],
  ['JOB-20-004-03', '20-004', 23, 'T', ''],
  ['JOB-20-005-01', '20-005', 4, 'I', ''],
  ['JOB-20-005-02', '20-005', 5, 'T', ''],
  ['JOB-20-005-03', '20-005', 6, 'M', ''],
  ['JOB-20-005-04', '20-005', 7, 'M', ''],
  ['JOB-20-006-01', '20-006', 4, 'I', ''],
  ['JOB-20-006-02', '20-006', 5, 'T', ''],
  ['JOB-20-006-03', '20-006', 6, 'M', ''],
  ['JOB-20-006-04', '20-006', 7, 'M', ''],
  ['JOB-20-007-01', '20-007', 21, 'I', ''],
  ['JOB-20-007-02', '20-007', 22, 'T', ''],
  ['JOB-20-007-03', '20-007', 23, 'T', ''],
  ['JOB-20-008-01', '20-008', 18, 'I', ''],
  ['JOB-20-008-02', '20-008', 19, 'T', ''],
  ['JOB-20-008-03', '20-008', 20, 'M', ''],
  ['JOB-20-009-01', '20-009', 4, 'I', ''],
  ['JOB-20-009-02', '20-009', 5, 'T', ''],
  ['JOB-20-009-03', '20-009', 6, 'M', ''],
  ['JOB-20-009-04', '20-009', 7, 'M', ''],
  ['JOB-20-010-01', '20-010', 4, 'I', ''],
  ['JOB-20-010-02', '20-010', 5, 'T', ''],
  ['JOB-20-010-03', '20-010', 6, 'M', ''],
  ['JOB-20-010-04', '20-010', 7, 'M', ''],
  ['JOB-20-011-01', '20-011', 4, 'I', ''],
  ['JOB-20-011-02', '20-011', 5, 'T', ''],
  ['JOB-20-011-03', '20-011', 6, 'M', ''],
  ['JOB-20-011-04', '20-011', 7, 'M', ''],
  ['JOB-20-012-01', '20-012', 4, 'I', ''],
  ['JOB-20-012-02', '20-012', 5, 'T', ''],
  ['JOB-20-012-03', '20-012', 6, 'M', ''],
  ['JOB-20-012-04', '20-012', 7, 'M', ''],
  ['JOB-21-001-01', '21-001', 4, 'I', ''],
  ['JOB-21-001-02', '21-001', 5, 'T', ''],
  ['JOB-21-001-03', '21-001', 6, 'M', ''],
  ['JOB-21-001-04', '21-001', 7, 'M', ''],
  ['JOB-21-002-01', '21-002', 18, 'I', ''],
  ['JOB-21-002-02', '21-002', 19, 'T', ''],
  ['JOB-21-002-03', '21-002', 20, 'M', ''],
  ['JOB-21-003-01', '21-003', 4, 'I', ''],
  ['JOB-21-003-02', '21-003', 5, 'T', ''],
  ['JOB-21-003-03', '21-003', 6, 'M', ''],
  ['JOB-21-003-04', '21-003', 7, 'M', ''],
  ['JOB-21-004-01', '21-004', 4, 'I', ''],
  ['JOB-21-004-02', '21-004', 5, 'T', ''],
  ['JOB-21-004-03', '21-004', 6, 'M', ''],
  ['JOB-21-004-04', '21-004', 7, 'M', ''],
  ['JOB-21-005-01', '21-005', 4, 'I', ''],
  ['JOB-21-005-02', '21-005', 5, 'T', ''],
  ['JOB-21-005-03', '21-005', 6, 'M', ''],
  ['JOB-21-005-04', '21-005', 7, 'M', ''],
  ['JOB-21-006-01', '21-006', 4, 'I', ''],
  ['JOB-21-006-02', '21-006', 5, 'T', ''],
  ['JOB-21-006-03', '21-006', 6, 'M', ''],
  ['JOB-21-006-04', '21-006', 7, 'M', ''],
  ['JOB-21-007-01', '21-007', 27, 'I', ''],
  ['JOB-21-007-02', '21-007', 28, 'T', ''],
  ['JOB-21-007-03', '21-007', 29, 'I', ''],
  ['JOB-21-008-01', '21-008', 18, 'I', ''],
  ['JOB-21-008-02', '21-008', 19, 'T', ''],
  ['JOB-21-008-03', '21-008', 20, 'M', ''],
  ['JOB-21-009-01', '21-009', 4, 'I', ''],
  ['JOB-21-009-02', '21-009', 5, 'T', ''],
  ['JOB-21-009-03', '21-009', 6, 'M', ''],
  ['JOB-21-009-04', '21-009', 7, 'M', ''],
  ['JOB-21-010-01', '21-010', 30, 'I', ''],
  ['JOB-21-010-02', '21-010', 31, 'T', ''],
  ['JOB-21-010-03', '21-010', 32, 'I', ''],
  ['JOB-21-011-01', '21-011', 4, 'I', ''],
  ['JOB-21-011-02', '21-011', 5, 'T', ''],
  ['JOB-21-011-03', '21-011', 6, 'M', ''],
  ['JOB-21-011-04', '21-011', 7, 'M', ''],
  ['JOB-21-012-01', '21-012', 18, 'I', ''],
  ['JOB-21-012-02', '21-012', 19, 'T', ''],
  ['JOB-21-012-03', '21-012', 20, 'M', ''],
  ['JOB-22-001-01', '22-001', 18, 'I', ''],
  ['JOB-22-001-02', '22-001', 19, 'T', ''],
  ['JOB-22-001-03', '22-001', 20, 'M', ''],
  ['JOB-22-002-01', '22-002', 30, 'I', ''],
  ['JOB-22-002-02', '22-002', 31, 'T', ''],
  ['JOB-22-002-03', '22-002', 32, 'I', ''],
  ['JOB-22-003-01', '22-003', 30, 'I', ''],
  ['JOB-22-003-02', '22-003', 31, 'T', ''],
  ['JOB-22-003-03', '22-003', 32, 'I', ''],
  ['JOB-22-004-01', '22-004', 18, 'I', ''],
  ['JOB-22-004-02', '22-004', 19, 'T', ''],
  ['JOB-22-004-03', '22-004', 20, 'M', ''],
  ['JOB-22-005-01', '22-005', 12, 'I', ''],
  ['JOB-22-005-02', '22-005', 13, 'T', ''],
  ['JOB-22-005-03', '22-005', 14, 'I', ''],
  ['JOB-22-006-01', '22-006', 30, 'I', ''],
  ['JOB-22-006-02', '22-006', 31, 'T', ''],
  ['JOB-22-006-03', '22-006', 32, 'I', ''],
  ['JOB-22-007-01', '22-007', 8, 'I', ''],
  ['JOB-22-007-02', '22-007', 9, 'T', ''],
  ['JOB-22-007-03', '22-007', 10, 'I', ''],
  ['JOB-22-007-04', '22-007', 11, 'T', ''],
  ['JOB-22-008-01', '22-008', 30, 'I', ''],
  ['JOB-22-008-02', '22-008', 31, 'T', ''],
  ['JOB-22-008-03', '22-008', 32, 'I', ''],
  ['JOB-22-009-01', '22-009', 8, 'I', ''],
  ['JOB-22-009-02', '22-009', 9, 'T', ''],
  ['JOB-22-009-03', '22-009', 10, 'I', ''],
  ['JOB-22-009-04', '22-009', 11, 'T', ''],
  ['JOB-22-010-01', '22-010', 4, 'I', ''],
  ['JOB-22-010-02', '22-010', 5, 'T', ''],
  ['JOB-22-010-03', '22-010', 6, 'M', ''],
  ['JOB-22-010-04', '22-010', 7, 'M', ''],
];
